
import React, { useState, useRef, useEffect, useLayoutEffect } from 'react';
import { Info, CloudUpload, X, ChevronDown, Search, Menu, Trash2, ChevronsUpDown, ChevronsDown, XCircle, ChevronRight, CircleCheck } from 'lucide-react';
import { useHistory } from "react-router-dom";
import Tooltip from '../addentities/Tooltip.js';
import { ReactSortable } from 'react-sortablejs';
import { createPortal } from 'react-dom';
import apiHelper from '../../apiHelper';
import { Routes } from "../../routes";
import CharacterLimitedTextarea from '../../components/CharacterLimitedTextarea';
import DiscardConfirmationModal from '../../components/DiscardConfirmationModal.js';
import UnsavedChangesPrompt from '../../components/UnsavedChangesPrompt.js';
import SpuProgressStepper from '../../components/SpuProgressStepper.js';
import SortableHeader from '../../components/SortableHeader.js';
import MultiSelectSearch from '../../utils/MultiSelectSearch.js';
import noImage from '../../assets/img/brand/noImage.png'

const MAX_IMAGES = 5;

// Reference children options

const REFERENCE_OPTIONS = {
    Brands: [
        { label: 'Apple', value: 'apple' },
        { label: 'Samsung', value: 'samsung' },
        { label: 'OnePlus', value: 'oneplus' },
        { label: 'Xiaomi', value: 'xiaomi' },
    ],
    Categories: [
        { label: 'Mobile', value: 'mobile' },
        { label: 'Tablet', value: 'tablet' },
        { label: 'Laptop', value: 'laptop' },
    ],
    SPU: [
        { label: 'iPhone 16', value: 'iphone-16' },
        { label: 'iPhone 16e', value: 'iphone-16e' },
        { label: 'iPhone 16 Pro Max', value: 'iphone-16pm' },
    ],
    SKU: [
        { label: 'iPhone 16 - Black-256GB-Wifi', value: 'sku-b256' },
        { label: 'iPhone 16 - Black-512GB-Wifi', value: 'sku-b512' },
        { label: 'iPhone 16 - Black-1TB-Wifi', value: 'sku-b1tb' },
    ],
};

{/* SHARED FUNCTION TO DISPLAY LABEL IN TWO LINES IF CONTAINS ' - ' */ }
const renderLabel = (label) => {
    const parts = label.split(' - ');
    if (parts.length === 2) {
        return (
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                <span style={{ color: '#6C757D', fontSize: '12px', marginBottom: '5px' }}>{parts[0]}</span>
                <span style={{ fontSize: '14px' }}>{parts[1]}</span>
            </div>
        );
    }
    return label;
};


// Configuration groups and options
const CONFIG_GROUPS = {
    Color: ['Desert Titanium', 'Natural Titanium', 'Black Titanium', 'White Titanium'],
    Storage: ['256GB', '512GB', '1TB'],
    Connectivity: ['Wi‑Fi', 'Wi‑Fi + Cellular'],
};

const portalRoot = document.getElementById('portal-root');
const OptionPortal = ({ children, style }) =>
    createPortal(
        <div className="options-container main-company-body-inner" style={{ ...style, overflow: 'visible', zIndex: 2000, marginTop: '10px' }}>
            {children}
        </div>,
        portalRoot
    );



export default function AddSpu() {
    const history = useHistory();
    const fileInputRef = useRef(null);

    const [uploadedImages, setUploadedImages] = useState([]);
    const [isDragging, setIsDragging] = useState(false);

    const [brands, setBrands] = useState([]);
    const [spus, setSpus] = useState([]);
    const [configImages, setConfigImages] = useState({});
    const [categories, setCategories] = useState([]);
    const [disabled, setDisabled] = useState(false);
    const [validationError, setValidationError] = useState([]);
    const [successMessage, setSuccessMessage] = useState('');
    const [spuid, setSpuId] = useState('')
    const [showMissingVariationError, setShowMissingVariationError] = useState(false);
    const [isDirty, setIsDirty] = useState(false);
    const [showTable, setShowTable] = useState(false);
    // CATEGORY — search term inside dropdown
    const [tempParentCategorySearchTerm, setTempParentCategorySearchTerm] = useState("");

    // CATEGORY — selected parent category filters (array)
    const [tempSearchParentCategory, setTempSearchParentCategory] = useState([]);

    // CATEGORY — dropdown open state
    const [parentCategoryDropdownOpen, setParentCategoryDropdownOpen] = useState(false);



    const [formData, setFormData] = useState({

        model_name: '',
        model_prefix: '',
        model_id: '',
        status: '1',
        os_type: '',
        brand_id: '',
        category_id: '',
        release_date: '',
        images: [],
        customised: [],
        notes: '',
    });

    const [errors, setFormErrors] = useState({
        model_name: '',
        brand_id: '',
        category_id: '',
        os_type: ''
    });
    const [rows2, setRows2] = useState([
        { id: 1, fieldName: '', opts: [], isOpen: false, search: '' },
    ]);
    const [skuCodeRows, setSkuCodeRows] = useState([]);


    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };


    // Cleanup all object URLs on unmount
    // run once on mount, cleanup on unmount
    useEffect(() => {
        return () => {
            uploadedImages.forEach(img => URL.revokeObjectURL(img.preview));
        };
    }, []);  // ← NO dependencies


    const handleBrowseClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };
    const [discardModalOpen, setDiscardModalOpen] = useState(false);
    const discardRef = useRef(null);
    const handleDiscard = () => {
        setDiscardModalOpen(true);
    };
    const handleDiscardConfirm = (confirm) => {
        if (confirm) {
            history.goBack();
        }
        setDiscardModalOpen(false);
    };
    const handleCancelDiscard = () => {
        setDiscardModalOpen(false);
    };
    // New state for configuration error
    const [configError, setConfigError] = useState('');

    // Function to check if SKU exists and update it

    const updateSKU = async (skuId, data) => {
        try {
            const isFormData = data instanceof FormData;
            const contentType = isFormData ? 'multipart/form-data' : 'application/json';

            const response = await apiHelper(
                `inventory/sku/${skuId}/update/`,
                'PUT',
                data,
                contentType
            );

            if (!response.ok) throw new Error('Failed to update SKU');
            return await response.json();
        } catch (error) {
            console.error('Error updating SKU:', error);
            throw error;
        }
    };
    useEffect(() => {
        return () => {
            // Cleanup all configuration image URLs
            Object.values(configImages).forEach(images => {
                images.forEach(img => URL.revokeObjectURL(img.preview));
            });
        };
    }, []);
    useEffect(() => {
        const combinations = generateCombinations(rows2);
        setSkuCodeRows(prevRows => {
            const newRows = combinations.map((combo, idx) => {
                // Find existing row to preserve user-entered values
                const existingRow = prevRows.find(row =>
                    row.specs.every((spec, i) => spec.group === combo[i]?.group && spec.value === combo[i]?.value)
                );
                return {
                    id: idx,
                    specs: combo,
                    specName: existingRow?.specName || combo.map(item => item.value).join('-'),
                    gtin: existingRow?.gtin || '',
                    skuCode: existingRow?.skuCode || combo.map(item => item.value).join('-'),
                    status: existingRow?.status || false,
                };
            });
            return newRows;
        });
    }, [rows2]);
    useEffect(() => {
        async function fetchBrandsData() {
            const response = await apiHelper('inventory/brands/?is_archived=false');
            if (response && response.ok) {
                const result = await response.json();
                setBrands(result);
            }
        }
        async function fetchCategoriesData() {
            const response = await apiHelper('inventory/categories/?is_archived=false');
            if (response && response.ok) {
                const result = await response.json();
                setCategories(result);
            }
        }
        async function fetchSKUAttributesData() {
            const response = await apiHelper('settings/sku-attributes/');
            if (response && response.ok) {
                const result = await response.json();
                console.log("SLU attributes", result)
                setSkuAttributes(result);
            }
        }
        async function fetchSKUAttributesOptionData() {
            const response = await apiHelper('settings/sku-attributes/options/');
            if (response && response.ok) {
                const result = await response.json();
                console.log("SLU attributes options", result)
                setSkuAttributeOptions(result)
            }
        }
        fetchSKUAttributesData();
        fetchSKUAttributesOptionData();
        fetchBrandsData();
        fetchCategoriesData();
    }, []);

    const makeImageObjects = (files) => {
        return files
            .slice(0, MAX_IMAGES - uploadedImages.length)
            .map(file => ({
                id: Date.now() + Math.random(),
                file,
                preview: URL.createObjectURL(file),
            }));
    };

    const handleImageChange = (e) => {
        console.log("Input files:", e.target.files);
        const files = Array.from(e.target.files || []);
        const newImgs = makeImageObjects(files);
        console.log("Will add:", newImgs);
        setUploadedImages(prev => [...prev, ...newImgs]);
        console.log("uploadedImages", uploadedImages)
        if(newImgs.length > 0) {
            errors.uploaded_images = "";
        }
            
    };
    const allowedImageTypes = ["image/jpeg", "image/png"];
    const maxSize = 1 * 1024 * 1024; // 1 MB
    const handleDrop = (e) => {
        e.preventDefault();
        setIsDragging(false);
        const files = Array.from(e.dataTransfer.files || []);
        const newImgs = makeImageObjects(files);
        console.log(newImgs);
        const invalidFile = {'status' : false, 'message': ''};
        newImgs.forEach((img) => {
                        
            if (!allowedImageTypes.includes(img.type)) {
                invalidFile.status = true;
                invalidFile.message = "Only JPEG and PNG files are allowed.";
            }

            if (img.size > maxSize) {
                invalidFile.status = true;
                invalidFile.message = "File size must be below 1 MB.";
            }
        });
        if(invalidFile.status) {
            // errors.uploaded_images = invalidFile.message;
            errors.uploaded_images = "Upload failed — Only JPEG/PNG files below 1MB are supported";
            return;
        }
        setUploadedImages(prev => [...prev, ...newImgs]);
        if(newImgs.length > 0) {
            errors.uploaded_images = "";
        }
    };

    const handleRemove = (id) => {
        setUploadedImages(uploadedImages.filter(x => x.id !== id));
    };
    // Configuration-specific image handlers
    const handleConfigImageChange = (e, tabKey) => {
        const files = Array.from(e.target.files || []);
        const newImgs = makeImageObjects(files);

        // Add spuId and tabKey (which represents the configuration/SKU) to each image
        const imagesWithMetadata = newImgs.map(img => ({
            ...img,
            spuId: spuid,
            skuIdentifier: tabKey // Using tabKey as SKU identifier
        }));

        setConfigImages(prev => ({
            ...prev,
            [tabKey]: [...(prev[tabKey] || []), ...imagesWithMetadata]
        }));
    };

    const handleConfigDrop = (e, tabKey) => {
        e.preventDefault();
        setIsDragging(false);
        const files = Array.from(e.dataTransfer.files || []);
        const newImgs = makeImageObjects(files);

        // Add spuId and tabKey to each image
        const imagesWithMetadata = newImgs.map(img => ({
            ...img,
            spuId: spuid,
            skuIdentifier: tabKey
        }));

        setConfigImages(prev => ({
            ...prev,
            [tabKey]: [...(prev[tabKey] || []), ...imagesWithMetadata]
        }));
    };

    const handleConfigRemove = (id, tabKey) => {
        setConfigImages(prev => ({
            ...prev,
            [tabKey]: (prev[tabKey] || []).filter(x => x.id !== id)
        }));
    };
    const formatSize = size => {
        const mb = size / (1024 * 1024);
        return `${mb.toFixed(1)}mb`;
    };
    function generateCombinations(variations) {
        if (!variations.length) return [];

        const combine = (arr, index = 0, current = [], results = []) => {
            if (index === variations.length) {
                results.push(current);
                return;
            }

            const { fieldName, opts } = variations[index];
            const attribute = skuAttributes.find(
                attr => attr && attr.attribute_id && attr.attribute_id.toString() === fieldName
            );

            const attributeName = attribute ? attribute.attribute_name : `Attribute ${fieldName}`;

            opts.forEach(opt => {
                combine(arr, index + 1, [...current, { group: attributeName, value: opt.label }], results);
            });

            return results;
        };

        return combine(variations);
    }
    const handleSaveSkuCode = async () => {
        try {
            console.log("Saving SKU Code")
            // Validate SKU Code rows
            if (skuCodeRows.length === 0) {
                // Assuming a similar validation state for SKU Code
                setShowMissingSku(true);
                return;
            }

            // Update SKUs for each SKU Code row
            for (const row of skuCodeRows) {
                const skuFilter = row.specs.reduce((acc, spec) => {
                    acc[spec.group] = spec.value;
                    return acc;
                }, {});
                console.log("row sku")

                // Fetch SKU by variation options
                // Assume API to fetch SKU by variation options
                const payload = { variations: skuFilter }
                payload['spu_id'] = spuid
                const response = await apiHelper('inventory/sku/search/',
                    'POST',
                    payload,
                    'application/json'
                );


                if (!response.ok) {
                    setConfigError('Error fetching SKU');
                    return;
                }

                const skuData = await response.json();
                if (!skuData || !skuData.sku_id) {
                    setConfigError(`No SKU found for specs: ${row.specs.map(s => `${s.group}:${s.value}`).join(', ')}`);
                    return;
                }

                // Update SKU with GTIN and SKU Code
                const formData = {
                    "spec_name": row.specName,
                    "gtin": row.gtin,
                    "sku_code": row.skuCode,
                }
                console.log("formData", formData)
                await updateSKU(skuData.sku_id, formData);
            }
            history.push('/spu-sku', { success: "SPU created successfully" });

            // Redirect based on button
            //   if (redirectTo === 'exit') {
            //     history.push('/spu-sku-list'); // Redirect to SPU/SKU list
            //   } else if (redirectTo === 'spu') {
            //     history.push(`/spu/${formData.id}`); // Redirect to SPU details
            //   }
        } catch (error) {
            setConfigError('Failed to save SKU codes');
        }
    };

    const [showItemAlert, setShowItemAlert] = useState(false);
    const [alert, setAlert] = useState({ message: "", type: "" });

    const handleSave = async () => {
        console.log("rows", rows);
        console.log("uploadedImages", uploadedImages)
        let postFormData = new FormData();

        if (uploadedImages.length) {
            let images = [];
            for (let i of uploadedImages) {
                images.push(i.file);
                postFormData.append('images', i.file);
            }
        }


        if (rows.length) {
            for (let row of rows) {
                if (row.value) {
                    let obj = { field_name: row.fieldName, type: row.fieldType, value: row.value };
                    postFormData.append('customised', JSON.stringify(obj));
                }
            }
        }


        setDisabled(true);
        let form_errors = { model_name: '', brand_id: '', category_id: '' };
        let is_error = false;
        if (!formData.model_name) {
            form_errors["model_name"] = "This field is required!";
            is_error = true;
        }
        if (!formData.brand_id) {
            form_errors["brand_id"] = "This field is required!";
            is_error = true;
        }
        if (!formData.category_id) {
            form_errors["category_id"] = "This field is required!";
            is_error = true;
        }
        if (!formData.os_type) {
            form_errors["os_type"] = "This field is required!";
            is_error = true;
        }

        setFormErrors(form_errors);
        if (is_error) {
            setDisabled(false);
            return false;
        }


        Object.keys(formData).forEach(key => {
            postFormData.append(key, formData[key]);
        });

        const response = await apiHelper('inventory/spus/create/', 'POST', postFormData, 'multipart/form-data');
        setDisabled(false);

        if (response) {
            console.log("spu response", response)
            if (response.ok) {
                const responseData = await response.json(); // Parse serializer.data
                console.log("SPU response data:", responseData); // Debug log
                const newSpuId = responseData.spu_id || responseData.id; // Adjust based on serializer field
                if (!newSpuId) {
                    console.error("SPU ID not found in response:", responseData);
                    setValidationError(["Failed to retrieve SPU ID. Please try again."]);
                    return;

                }
                setSpuId(newSpuId); // Update spuid st
                setAlert({ message: "SPU created successfully", type: "success" });
                setValidationError([]);
                setUploadedImages([]);

                setFormData({
                    model_name: '',
                    model_prefix: '',
                    status: '1',
                    os_type: '',
                    brand_id: '',
                    category_id: '',
                    release_date: '',
                    images: [],
                    customised: [],
                    notes: '',
                });
                history.push("/spu-sku")
            }
            else if (response.status == 400) { //for validation error
                const response_errors = await response.json();
                let errors = [];
                for (let i in response_errors) {
                    errors.push(`${i}: ${response_errors[i][0]}`);
                }
                setValidationError(errors);
                setAlert({ message: "Failed to create SPU", type: "error" });
            }
        }

    };
    const saveVariation = async () => {
        const variationGroups = rows2.map(row => ({
            attribute_id: row.fieldName,
            options: row.opts.filter(opt => opt && opt.value?.trim()), // Check if value is non-empty
        }));

        // Step 2: Validate variations
        if (variationGroups.length === 0 || variationGroups.some(group => group.options.length === 0)) {
            setValidationError(['At least one variation with valid options is required.']);
            setDisabled(false);
            return;
        }

        // Rest of the function remains unchanged
        const generateCombinations = (groups) => {
            return groups.reduce((acc, group) => {
                const result = [];
                const options = group.options;
                if (acc.length === 0) {
                    return options.map(opt => [{ attribute_id: group.attribute_id, option: opt.value }]);
                }
                acc.forEach(comb => {
                    options.forEach(opt => {
                        result.push([...comb, { attribute_id: group.attribute_id, option: opt.value }]);
                    });
                });
                return result;
            }, []);
        };

        const combinations = generateCombinations(variationGroups);

        const skuDataArray = combinations.map(combination => {
            const skuData = {
                spu: spuid,
                status: false,
                color: '',
                storage: '',
                memory_ram: '',
                barcode_ean_upc: '',
                gtin: '',
                launch_price: 0,
                notes: '',
            };

            combination.forEach(({ attribute_id, option }) => {
                const attribute = skuAttributes.find(attr => attr.attribute_id === parseInt(attribute_id));
                if (attribute) {
                    const fieldName = attribute?.attribute_name.toLowerCase().replace(/\s+/g, '_');
                    if (['color', 'storage', 'memory_ram', 'barcode_ean_upc', 'gtin', 'launch_price'].includes(fieldName)) {
                        skuData[fieldName] = option;
                    }
                }
            });

            const hasVariation = ['color', 'storage', 'memory_ram', 'barcode_ean_upc', 'gtin'].some(field => skuData[field]);
            if (!hasVariation) {
                return null;
            }

            return skuData;
        }).filter(skuData => skuData !== null);

        if (skuDataArray.length === 0) {
            setValidationError(['No valid SKU combinations generated. Please check variation options.']);
            setDisabled(false);
            return;
        }

        for (const skuData of skuDataArray) {
            const response = await apiHelper('inventory/sku/create/', 'POST', skuData);
            if (!response.ok) {
                const errorData = await response.json();
                setValidationError(Object.values(errorData).flat().join(', '));
                setDisabled(false);
                return;
            }
        }
        setSuccessMessage('SKU variations created successfully.');
    }
    const handleSaveVariations = async () => {
        // Validate variations
        const hasValidVariations = rows2.length > 0 && rows2.every(row => row.opts.length > 0);

        if (!hasValidVariations) {
            setShowMissingVariationError(true);
            return;
        }

        try {
            setDisabled(true);
            // Save variations and create SKUs
            await saveVariation();
            history.push('/spu-sku');
            setSuccessMessage('SKU variations created successfully.');
            setValidationError([]);
        } catch (e) {
            console.error('Error saving variations:', e);
            setValidationError(['Failed to save SKU variations.']);
        } finally {
            setDisabled(false);
        }
    };
    useEffect(() => {
        function handleClickOutside(event) {
            if (discardRef.current && !discardRef.current.contains(event.target)) {
                setDiscardModalOpen(false);
            }
        }
        if (discardModalOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        }
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [discardModalOpen]);


    // const [formData, setFormData] = useState({
    //     profile_image: null,
    //     first_name: '',
    //     last_name: '',
    //     status: '0',
    //     display_name: '',
    //     compatibility: [],
    //     company_email: '',
    //     personal_email: '',
    //     country_code: '+91',
    //     phone_number: '',
    //     departments: [],
    //     manager: '',
    //     entities: [],
    //     workplaces: [],
    //     job_title: '',
    //     onboard_date: '',
    //     notes: '',
    // });
    const [rows3, setRows3] = useState([
        { id: 1, fieldName: '', opts: [], isOpen: false }
        // { id: 2, fieldName: 'Black iPhone 16 Pro Max', opts: [], isOpen: false },
    ]);
    const rowRefs3 = useRef({});

    const addRow3 = () => {
        if (isAddConfigDisabled) return;
        const newId = rows3.length ? Math.max(...rows3.map(r => r.id)) + 1 : 1;
        setRows3([...rows3, { id: newId, fieldName: '', opts: [], isOpen: false }]);
    };
    const deleteRow3 = id => setRows3(rows3.filter(r => r.id !== id));
    const updateRow3 = (id, changes) =>
        setRows3(rows3.map(r => (r.id === id ? { ...r, ...changes } : r)));

    // Close dropdown on outside click
    useEffect(() => {
        const handler = e => {
            const inPortal = portalRoot?.contains(e.target);
            setRows3(rs =>
                rs.map(r => {
                    const el = rowRefs3.current[r.id]?.current;
                    if (!inPortal && el && !el.contains(e.target)) {
                        return { ...r, isOpen: false };
                    }
                    return r;
                })
            );
        };
        document.addEventListener('mousedown', handler);
        return () => document.removeEventListener('mousedown', handler);
    }, []);

    // const [selectedCompatibility, setSelectedCompatibility] = useState([]);
    // const [isCompatibilityOpen, setIsCompatibilityOpen] = useState(false);
    // const [compatibilitySearch, setCompatibilitySearch] = useState('');
    const [isAddVariationDisabled, setIsAddVariationDisabled] = useState(false);
    const [isAddConfigDisabled, setIsAddConfigDisabled] = useState(false);
    const [allCompatibility, setAllCompatibility] = useState([
        { role_name: 'iPhone 16 Pro', id: '1' },
        { role_name: 'iPhone 16e', id: '2' },
        { role_name: 'iPhone 16 Pro Max', id: '3' },
        { role_name: 'iPhone 16', id: '4' },
    ]);

    // const [allCompatibility, setAllCompatibility] = useState([]);
    useEffect(() => {
        if (rows2.length > 0) {
            const lastRow = rows2[rows2.length - 1];
            setIsAddVariationDisabled(!lastRow.fieldName || lastRow.opts.length === 0);
        } else {
            setIsAddVariationDisabled(false);
        }
    }, [rows2]);

    useEffect(() => {
        if (rows3.length > 0) {
            const lastRow = rows3[rows3.length - 1];
            setIsAddConfigDisabled(!lastRow.fieldName || lastRow.opts.length !== rows2.length);
        } else {
            setIsAddConfigDisabled(false);
        }
    }, [rows3, rows2]);




    const [activeTab2, setActiveTab2] = useState('edit-spu');
    const breadcrumbs = ["Product", "SPU & SKU", "Add SPU"];

    const [rows, setRows] = useState([
        {
            id: 1, fieldName: '',
            fieldType: 'Text',      // or 'Reference'
            refChild: '',           // one of REFERENCE_CHILDREN
            value: '',              // for Text
            opts: [],               // for multi‑select
            typeOpen: false,        // dropdown open?
            refMenuOpen: false,     // submenu open?
            isOpen: false,          // multi‑select open?
            search: ''              // multi‑select search
        }

    ]);
    const rowRefs = useRef({});
    const [isAddCustomDisabled, setIsAddCustomDisabled] = useState(false);

    useEffect(() => {
        if (rows.length > 0) {
            const lastRow = rows[rows.length - 1];
            setIsAddCustomDisabled(!lastRow.fieldName.trim() || (lastRow.fieldType === 'Text' && !lastRow.value.trim()));
        } else {
            setIsAddCustomDisabled(false);
        }
    }, [rows]);
    const addRow = () => {
        if (isAddCustomDisabled) return;
        const newId = rows.length ? Math.max(...rows.map(r => r.id)) + 1 : 1;
        setRows([...rows, { id: newId, fieldName: '', fieldType: 'Text', refChild: '', value: '', opts: [], typeOpen: false, refMenuOpen: false, isOpen: false, search: '' }]);
    };
    const deleteRow = id => setRows(rows.filter(r => r.id !== id));
    const updateRowBulk = (id, changes) => setRows(rows.map(r => r.id === id ? { ...r, ...changes } : r));

    // Close dropdowns on outside click
    useEffect(() => {
        const handler = e => {
            const inPortal = portalRoot?.contains(e.target);
            setRows(rs => rs.map(r => {
                const el = rowRefs.current[r.id]?.current;
                if (!inPortal && el && !el.contains(e.target)) {
                    return { ...r, typeOpen: false, refMenuOpen: false, isOpen: false };
                }
                return r;
            }));
        };
        document.addEventListener('mousedown', handler);
        return () => document.removeEventListener('mousedown', handler);
    }, []);

    const [showMissingSku, setShowMissingSku] = useState(true);

    // inside your component, after your useState:
    useEffect(() => {
        if (rows.length === 0) {
            setShowMissingSku(true);
        }
    }, [rows.length]);

    const archivedRef = useRef(null);
    const [archivedModalOpen, setArchivedModalOpen] = useState(false);
    const [selectedEmployeeId, setSelectedEmployeeId] = useState(null); // optional

    const handleArchivedConfirm = () => {
        console.log("Archiving:", selectedEmployeeId); // or your logic
        setArchivedModalOpen(false);
    };

    useEffect(() => {
        function handleClickOutside(event) {
            if (archivedRef.current && !archivedRef.current.contains(event.target)) {
                setArchivedModalOpen(false);
            }
        }

        if (archivedModalOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [archivedModalOpen]);

    const [skuAttributes, setSkuAttributes] = useState([]);
    const [skuAttributeOptions, setSkuAttributeOptions] = useState([]);
    //Tab 2

    const rowRefs2 = useRef({});
    const [showMissingVar, setShowMissingVar] = useState(true);

    // show alert if no rows
    useEffect(() => {
        if (rows2.length === 0) setShowMissingVar(true);
    }, [rows2.length]);

    const addRow2 = () => {
        if (isAddVariationDisabled) return;
        const lastRow = rows2[rows2.length - 1];
        // Check if last row has both fieldName and at least one option selected
        if (rows2.length > 0 && (!lastRow.fieldName || lastRow.opts.length === 0)) {
            setValidationError(['Please fill in the Variation Name and at least one Variation option before adding a new row.']);
            return;
        }
        const newId = rows2.length ? Math.max(...rows2.map(r => r.id)) + 1 : 1;
        setRows2([...rows2, { id: newId, fieldName: '', opts: [], isOpen: false, search: '' }]);
    };

    const deleteRow2 = id => setRows2(rows2.filter(r => r.id !== id));
    const updateRow2 = (id, changes) =>
        setRows2(rows2.map(r => (r.id === id ? { ...r, ...changes } : r)));

    // close dropdowns on outside click
    useEffect(() => {
        const handler = e => {
            const inPortal = portalRoot?.contains(e.target);
            setRows2(rs =>
                rs.map(r => {
                    const el = rowRefs2.current[r.id]?.current;
                    if (!inPortal && el && !el.contains(e.target)) {
                        return { ...r, isOpen: false };
                    }
                    return r;
                })
            );
        };
        document.addEventListener('mousedown', handler);
        return () => document.removeEventListener('mousedown', handler);
    }, []);

    //Tab 3

    const currentRowsEmpty =
        activeTab2 === 'sku-variations'
            ? rows2.length === 0
            : activeTab2 === 'sku-configurations'
                ? rows3.length === 0
                : rows.length === 0;

    const [showMissingCfg, setShowMissingCfg] = useState(true);

    // reset the alert whenever rows3 goes to zero
    useEffect(() => {
        if (rows3.length === 0) {
            setShowMissingCfg(true);
        }
    }, [rows3.length]);

    //Tab 3 same data of input field alert box code

    // new state for the “exists” alert
    const [showCfgExists, setShowCfgExists] = useState(false);

    // whenever rows3 changes, check for duplicate fieldName
    useEffect(() => {
        const names = rows3.map(r => r.fieldName.trim()).filter(n => n);
        const hasDup = names.some((n, i) => names.indexOf(n) !== i);
        setShowCfgExists(hasDup);
    }, [rows3]);
    const productTabs = rows3.map(row => ({
        key: row.fieldName.toLowerCase().replace(/\s+/g, '-'),
        label: row.fieldName || `Configuration ${row.id}`,
    }));
    const [productTab, setProductTab] = useState('white-iphone-16-pro-max');

    //Tab 3 product info tabs code below
    const [activeTab, setActiveTab] = useState(productTabs[0]?.key || '');
    const [overflowTabs, setOverflowTabs] = useState([]);
    const [menuOpen, setMenuOpen] = useState(false);
    const [menuStyles, setMenuStyles] = useState({ top: 0, left: 0, direction: "down" });
    const containerRef = useRef(null);
    const triggerRef = useRef(null);
    const tabRefs = useRef({});

    function calcOverflow() {
        if (!containerRef.current) return;
        const contW = containerRef.current.clientWidth;
        const trigW = triggerRef.current?.offsetWidth || 40;
        let used = 0;
        const vis = [];
        const over = [];

        productTabs.forEach(tab => {
            const btn = tabRefs.current[tab.key];
            if (!btn) return;
            const w = btn.offsetWidth;
            if (tab.key === activeTab || used + w < contW - trigW) {
                vis.push(tab.key);
                used += w;
            } else {
                over.push(tab.key);
            }
        });

        setOverflowTabs(over);
    }

    // measure before paint so icon is in right place
    useLayoutEffect(() => {
        requestAnimationFrame(() => {
            calcOverflow();
            scrollActiveTabIntoView();
        });
    }, [activeTab, rows3]);

    function scrollActiveTabIntoView() {
        const activeEl = tabRefs.current[activeTab];
        if (activeEl && containerRef.current) {
            activeEl.scrollIntoView({
                behavior: "smooth",
                inline: "center",
                block: "nearest"
            });
        }
    }


    // recalc on resize
    useEffect(() => {
        window.addEventListener("resize", calcOverflow);
        return () => window.removeEventListener("resize", calcOverflow);
    }, []);

    function toggleMenu() {
        if (!triggerRef.current) return;
        const rect = triggerRef.current.getBoundingClientRect();
        const spaceBelow = window.innerHeight - rect.bottom;
        const direction = spaceBelow < 200 ? "up" : "down";
        setMenuStyles({
            top: direction === "down" ? rect.bottom + window.scrollY : rect.top + window.scrollY,
            left: rect.right + window.scrollX - 200, // 200 = approx menu width
            direction
        });
        setMenuOpen(open => !open);
    }

    // render the portal menu
    const portalMenu = menuOpen && createPortal(
        <ul
            className={`pt-portal-menu ${menuStyles.direction}`}
            style={{
                position: "absolute",
                top: `${menuStyles.top}px`,
                left: `${menuStyles.left}px`
            }}
        >
            {productTabs.map(tab => (
                <li key={tab.key}>
                    <button
                        className={`pt-portal-item ${activeTab === tab.key ? "selected" : ""}`}
                        onClick={() => {
                            setActiveTab(tab.key);
                            setMenuOpen(false);
                        }}
                    >
                        {tab.label}
                    </button>
                </li>
            ))}
        </ul>,
        document.body
    );

    const saveRef = useRef(null);
    const [saveModalOpen, setSaveModalOpen] = useState(false);
    const handleSaveConfirm = () => {
        let config_errors = [];
        for (let row of rows3) {
            if (!row.fieldName || row.opts.length !== rows2.length) {
                config_errors.push('All configurations must have a name and one option selected per variation group.');
            }
        }
        if (config_errors.length) {
            setValidationError(config_errors);
            setShowCfgExists(true); // Reuse existing alert state for error
            setDisabled(false);
            return;
        }
        setSaveModalOpen(false);
    };

    useEffect(() => {
        function handleClickOutside(event) {
            if (saveRef.current && !saveRef.current.contains(event.target)) {
                setSaveModalOpen(false);
            }
        }

        if (saveModalOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [saveModalOpen]);

    const saveRef2 = useRef(null);
    const [saveModalOpen2, setSaveModalOpen2] = useState(false);
    const handleSaveConfirm2 = () => {
        setSaveModalOpen2(false);
    };

    useEffect(() => {
        function handleClickOutside2(event) {
            if (saveRef2.current && !saveRef2.current.contains(event.target)) {
                setSaveModalOpen2(false);
            }
        }

        if (saveModalOpen2) {
            document.addEventListener("mousedown", handleClickOutside2);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside2);
        };
    }, [saveModalOpen2]);

    // State for OS Type dropdown
    const [isOsTypeOpen, setIsOsTypeOpen] = useState(false);
    const [osTypeSearch, setOsTypeSearch] = useState('');
    const osTypeRef = useRef(null);

    const osTypeOptions = ['Device', 'Smartphone', 'Tablet'];

    // Toggle dropdown
    const toggleOsType = () => {
        setIsOsTypeOpen((prev) => !prev);
    };

    // Filter options
    const filteredOsTypes = osTypeOptions.filter((item) =>
        item.toLowerCase().includes(osTypeSearch.toLowerCase())
    );

    // Select an option
    const handleOsTypeSelect = (value) => {
        setFormData({ ...formData, os_type: value });
        setIsOsTypeOpen(false);
    };

    // Close when clicking outside
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (isOsTypeOpen && osTypeRef.current && !osTypeRef.current.contains(e.target)) {
                setIsOsTypeOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOsTypeOpen]);

    // State for Category dropdown
    const [isCategoryOpen, setIsCategoryOpen] = useState(false);
    const [categorySearch, setCategorySearch] = useState('');
    const categoryRef = useRef(null);

    // Filtered list
    const filteredCategories = categories?.filter((item) =>
        item.category_name.toLowerCase().includes(categorySearch.toLowerCase())
    ) || [];

    // Toggle dropdown
    const toggleCategory = () => {
        setIsCategoryOpen((prev) => !prev);
    };

    // Select a category
    const handleCategorySelect = (item) => {
        setFormData({ ...formData, category_id: item.category_id });
        setIsCategoryOpen(false);
    };

    // Close on outside click
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (isCategoryOpen && categoryRef.current && !categoryRef.current.contains(e.target)) {
                setIsCategoryOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isCategoryOpen]);

    // State for Brand dropdown
    const [isBrandOpen, setIsBrandOpen] = useState(false);
    const [brandSearch, setBrandSearch] = useState('');
    const brandRef = useRef(null);

    // Filtered list
    const filteredBrands = brands?.filter((item) =>
        item.brand_name.toLowerCase().includes(brandSearch.toLowerCase())
    ) || [];

    // Toggle dropdown
    const toggleBrand = () => {
        setIsBrandOpen((prev) => !prev);
    };

    // Select a brand
    const handleBrandSelect = (item) => {
        setFormData({ ...formData, brand_id: item.brand_id });
        setIsBrandOpen(false);
    };

    // Close on outside click
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (isBrandOpen && brandRef.current && !brandRef.current.contains(e.target)) {
                setIsBrandOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isBrandOpen]);

    const handleSaveAndAddToSKU = async () => {
        let postFormData = new FormData();

        if (uploadedImages.length) {
            for (let i of uploadedImages) {
                postFormData.append('images', i.file);
            }
        }

        if (rows.length) {
            for (let row of rows) {
                if (row.value) {
                    let obj = { field_name: row.fieldName, type: row.fieldType, value: row.value };
                    postFormData.append('customised', JSON.stringify(obj));
                }
            }
        }

        setDisabled(true);
        let form_errors = { model_name: '', brand_id: '', category_id: '', os_type: '' };
        let is_error = false;
        if (!formData.model_name) {
            form_errors["model_name"] = "This field is required!";
            is_error = true;
        }
        if (!formData.brand_id) {
            form_errors["brand_id"] = "This field is required!";
            is_error = true;
        }
        if (!formData.category_id) {
            form_errors["category_id"] = "This field is required!";
            is_error = true;
        }
        if (!formData.os_type) {
            form_errors["os_type"] = "This field is required!";
            is_error = true;
        }
            
        if (uploadedImages.length == 0) {
            form_errors["uploaded_images"] = "This field is required!";
            is_error = true;
        }
        /*
        if (rows.length > 0) {
            const invalidRows = {}
            rows.forEach((r, ind) => {
                console.log(r);
            });
            form_errors["uploaded_images"] = "This field is required!";
            is_error = true;
        }
            */
    

        setFormErrors(form_errors);
        if (is_error) {
            setDisabled(false);
            return false;
        }

        Object.keys(formData).forEach(key => {
            postFormData.append(key, formData[key]);
        });

        const response = await apiHelper('inventory/spus/create/', 'POST', postFormData, 'multipart/form-data');
        setDisabled(false);

        if (response) {
            if (response.ok) {
                const responseData = await response.json();
                const newSpuId = responseData.spu_id || responseData.id;
                if (!newSpuId) {
                    setValidationError(["Failed to retrieve SPU ID. Please try again."]);
                    return;
                }
                setSpuId(newSpuId);
                setSuccessMessage('SPU created successfully.');
                setValidationError([]);
                setUploadedImages([]);
                setFormData({
                    model_name: '',
                    model_prefix: '',
                    status: '1',
                    os_type: '',
                    brand_id: '',
                    category_id: '',
                    release_date: '',
                    images: [],
                    customised: [],
                    notes: '',
                });
                // Navigate to SKU Variations tab
                setActiveTab2('sku-variations');
            } else if (response.status === 400) {
                const response_errors = await response.json();
                let errors = [];
                for (let i in response_errors) {
                    errors.push(`${i}: ${response_errors[i][0]}`);
                }
                setValidationError(errors);
                setSuccessMessage('');
            }
        }
    };
    // Update handleSaveAndConfigureSKU to check for variations and options
    const handleSaveAndConfigureSKU = async () => {
        // Check if there are no variations or no variation has options
        const hasValidVariations = rows2.length > 0 && rows2.every(row => row.opts.length > 0);

        if (!hasValidVariations) {
            setShowMissingVariationError(true);
            return;
        }

        // Existing save logic
        try {
            // setIsLoading(true);
            const variations = rows2.map(r => ({
                attribute_id: r.fieldName,
                option_values: r.opts.map(o => o.value)
            }));
            const payload = { variations };

            // await apiHelper('skus/attributes', 'post', payload);
            await saveVariation();
            setSuccessMessage('SKU variations created successfully.');
            setValidationError([]);
            setActiveTab2('sku-configurations');
        } catch (e) {
            console.error(e);
        } finally {
            // setIsLoading(false);
        }
    };

    const formatSkuPayload = (configRows, customRows, spuId, images) => {
        const skus = configRows.map(row => {
            const skuData = {
                configuration_name: row.fieldName || '',
                spu: spuId,
                status: false,
                launch_price: 0.00,
                notes: formData.notes || '',
                customised_info: customRows.map(custom => ({
                    field_name: custom.fieldName || '',
                    field_type: custom.fieldType || 'Text',
                    field_value: custom.fieldType === 'Text' ? custom.value || '' : (custom.opts || []).map(opt => opt.label).join(', '),
                })),
            };

            (row.opts || []).forEach(opt => {
                const [key, value] = opt.split(':');
                if (key.toLowerCase() === 'color') skuData.color = value || '';
                if (key.toLowerCase() === 'storage') skuData.storage = value || '';
                if (key.toLowerCase() === 'memory') skuData.memory_ram = value || '';
            });

            const activeTabImages = images.filter(img => img.tabKey === activeTab);
            if (activeTabImages.length > 0) {
                skuData.sku_image = activeTabImages[0]?.file;
            }

            return skuData;
        });

        return { skus };
    };

    // Modified handleSave for SKU Configurations
    const handleSaveConfigurations = async (redirectTo) => {
        setConfigError('');
        try {
            // Validate configurations
            if (rows3.length === 0) {
                setShowMissingCfg(true);
                return;
            }

            // Check and update SKUs for each configuration
            for (const row of rows3) {
                const configOptions = row.opts;
                if (!configOptions.length) {
                    setConfigError('No configuration options selected');
                    return;
                }

                // Construct filter to find SKU
                const skuFilter = configOptions.reduce((acc, opt) => {
                    const [group, value] = opt.split(':');
                    acc[group] = value;
                    return acc;
                }, {});

                const payload = { variations: skuFilter };
                payload['spu_id'] = spuid;

                // Find SKU by variation options
                const response = await apiHelper('inventory/sku/search/',
                    'POST',
                    payload,
                    'application/json'
                );

                if (!response.ok) {
                    setConfigError('Error fetching SKU');
                    return;
                }

                const skuData = await response.json();
                if (!skuData || !skuData.sku_id) {
                    setConfigError(`No SKU found for configuration: ${configOptions.join(', ')}`);
                    return;
                }

                // Prepare form data for SKU update with images
                const updateData = new FormData();
                updateData.append('configuration_name', row.fieldName);

                // Add SPU ID to the payload
                updateData.append('spu_id', spuid);

                // Add SKU ID to the payload
                updateData.append('sku_id', skuData.sku_id);

                // Add images for this configuration if they exist
                const tabKey = row.fieldName.toLowerCase().replace(/\s+/g, '-');
                const imagesForConfig = configImages[tabKey] || [];

                if (imagesForConfig.length > 0) {
                    imagesForConfig.forEach(img => {
                        // Each image already has spuId and skuIdentifier metadata
                        updateData.append('images', img.file);

                        // Add metadata for each image
                        updateData.append('image_metadata', JSON.stringify({
                            spu_id: img.spuId,
                            sku_identifier: img.skuIdentifier,
                            // You might want to add the actual SKU ID here if available
                            // sku_id: skuData.sku_id
                        }));
                    });
                }

                // Update SKU with configuration name and images
                await updateSKU(skuData.sku_id, updateData);
            }

            // Redirect based on button
            if (redirectTo === 'spu-list') {
                history.push('/spu-sku');
            } else if (redirectTo === 'sku-code') {
                setActiveTab2('sku-code');
            }
        } catch (error) {
            setConfigError('Failed to save configurations');
        }
    };
    const handleChangeWithDirty = (e) => {
        setIsDirty(true);
        handleChange(e);
    };

    const stepMapping = {
        "edit-spu": 1,
        "sku-variations": 2,
        "sku-configurations": 3,
        "sku-code": 4
    };


    const tabContent = {
        'edit-spu': {
            heading: "SPU",
            buttons: ["discard", "next"]
        },
        'sku-variations': {
            heading: "SKU Variations",
            buttons: ["discard", "back", "next"]
        },
        'sku-configurations': {
            heading: "SKU Configurations",
            buttons: ["discard", "back", "next"]
        },
        'sku-code': {
            heading: "SKU Info",
            buttons: ["discard", "back", "save"]
        }
    };
    const currentTab = tabContent[activeTab2];
    const handleBack = () => {
        if (activeTab2 === "sku-variations") setActiveTab2("edit-spu");
        if (activeTab2 === "sku-configurations") setActiveTab2("sku-variations");
        if (activeTab2 === "sku-code") setActiveTab2("sku-configurations");
    };

    // ---- NEXT BUTTON HANDLER (your existing logic) ----
    const handleNext = () => {
        if (activeTab2 === "edit-spu") handleSaveAndAddToSKU();
        if (activeTab2 === "sku-variations") handleSaveAndConfigureSKU();
        if (activeTab2 === "sku-configurations") handleSaveConfigurations("sku-code");
    };

    const [sortField, setSortField] = useState(null);
    const [sortOrder, setSortOrder] = useState(null); // "asc" | "desc"

    const handleSort = (field) => {
        if (sortField === field) {
            // toggle asc/desc
            setSortOrder(sortOrder === "asc" ? "desc" : "asc");
        } else {
            setSortField(field);
            setSortOrder("asc"); // default sort order
        }
    };

    const getUniqueParentCategories = (categories) => {
        const map = new Map();

        categories.forEach((cat) => {
            if (!map.has(cat.parent_name)) {
                map.set(cat.parent_name, {
                    parent_name: cat.parent_name,
                    parent_parent_name: cat.parent_parent_name,
                });
            }
        });

        return Array.from(map.values()).filter(item => item.parent_name);
    };

    return (
        <>{activeTab2 === 'sku-variations' && (
            <div className="tab-content" id="sku-variations-content">
                <div className="info-section">
                    <div className="info-card new-info-overflow-auto main-company-body-inner">
                        {/* <div style={{ padding: '20px', boxShadow: '0px 1px 4px #0000001A', borderRadius: '12px' }}> */}
                        {alert.message && (
                            <div
                                className="d-flex align-items-center justify-content-between"
                                role="alert"
                                style={{
                                    boxShadow: "0px 4px 10px 0px #0000001F",
                                    padding: "15px 10px",
                                    borderRadius: "12px",
                                    border: alert.type === "success" ? "1px solid #28a745" : "1px solid #dc3545",
                                    backgroundColor: alert.type === "success" ? "#E6F7EF" : "#F8D7DA",
                                    color: alert.type === "success" ? "#0D6438" : "#721c24",
                                    fontSize: "12px",
                                    position: "fixed",
                                    top: "10px",
                                    width: "calc(100% - 20px)",
                                    maxWidth: "640px",
                                    left: "50%",
                                    transform: "translateX(-50%)",
                                    zIndex: 2000,
                                }}
                            >
                                <div className="d-flex align-items-center">
                                    {alert.type === "success" ? <CircleCheck className="me-2" /> : <Info className="me-2" />}
                                    <strong>{alert.message}</strong>
                                </div>
                                <X size={16} style={{ cursor: "pointer" }} onClick={() => setAlert({ message: "", type: "" })} />
                            </div>
                        )}
                        {/* Existing content (rows2.length === 0 && showMissingVar, table, etc.) remains unchanged */}
                        {/* </div> */}
                    </div>
                </div>
            </div>
        )}
            <div className="company-body main-company-body-inner new-look">
                <div className="breadcrumb">
                    {breadcrumbs.map((crumb, index) => {
                        const isLast = index === breadcrumbs.length - 1;
                        return (
                            <span
                                key={index}
                                className={`breadcrumb-item ${crumb === "SPU & SKU" ? "clickable" : ""}`}
                                onClick={() => {
                                    if (crumb === "SPU & SKU") {
                                        history.push("/spu-sku");
                                    }
                                }}
                                style={{ cursor: crumb === "SPU & SKU" ? "pointer" : "default" }}
                            >
                                {crumb}
                                {!isLast ? "  " : ""}
                            </span>
                        );
                    })}
                </div>
                <div className="progress-stepper-container mb-4">
                    <SpuProgressStepper currentStep={stepMapping[activeTab2]} />
                </div>
                <div className='edit-organisation-info'>

                    <div className='edit-organisation-left'>
                        <h1>{currentTab.heading}</h1>
                    </div>

                    <div className='discard-save-organisation-right d-flex align-items-center justify-content-end flex-wrap gap-2'>

                        {/* DISCARD BUTTON */}
                        {currentTab.buttons.includes("discard") && (
                            <button
                                className="dark-button"
                                type='button'
                                onClick={handleDiscard}
                            >
                                Discard
                            </button>
                        )}

                        <DiscardConfirmationModal
                            isOpen={discardModalOpen}
                            onCancel={handleCancelDiscard}
                            onConfirm={handleDiscardConfirm}
                            entityName="Spu"
                        />

                        {/* BACK BUTTON */}
                        {currentTab.buttons.includes("back") && (
                            <button
                                className="dark-button"
                                type="button"
                                onClick={handleBack}
                            >
                                Back
                            </button>
                        )}

                        {/* NEXT BUTTON */}
                        {currentTab.buttons.includes("next") && (
                            <button
                                className={`dark-border ${currentRowsEmpty ? 'disabled' : ''}`}
                                type="button"
                                onClick={handleNext}
                                disabled={currentRowsEmpty}
                                style={currentRowsEmpty ? {
                                    display: 'flex',
                                    height: '34px',
                                    minWidth: '100px',
                                    padding: '8px',
                                    justifyContent: 'center',
                                    alignContent: 'center',
                                    gap: '10px',
                                    borderRadius: '8px',
                                    boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.10)",
                                } : {}}
                            >
                                Next
                            </button>
                        )}

                        {/* SAVE BUTTON — only for SKU CODE */}
                        {currentTab.buttons.includes("save") && (
                            <button
                                className={`dark-button ${currentRowsEmpty ? 'disabled' : ''}`}
                                type="button"
                                onClick={handleSaveSkuCode}
                                disabled={currentRowsEmpty}
                                style={currentRowsEmpty ? {
                                    backgroundColor: '#CED4DA',
                                    color: '#fff',
                                    borderColor: 'transparent'
                                } : {}}
                            >
                                Save
                            </button>
                        )}
                    </div>
                </div>

                {saveModalOpen && (
                    <>
                        <div className="drawer-overlay" />
                        <div
                            className="entity-drawer modal-popup-cls"
                            ref={saveRef}
                            style={{
                                maxWidth: 650,
                                margin: "0 auto",
                                background: "white",
                                borderRadius: 12,
                                zIndex: 1050,
                                padding: 24,
                                position: "fixed",
                                top: "50%",
                                left: "50%",
                                transform: "translate(-50%, -50%)",
                                boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.2)",
                                height: "auto",
                                right: "auto",
                                overflow: "inherit",
                            }}
                        >
                            <div className="drawer-header d-flex justify-content-end align-items-center pt-0 pe-0">
                                <button className="close-btn" onClick={() => setSaveModalOpen(false)}>
                                    <X size={20} />
                                </button>
                            </div>
                            <h3 style={{ textAlign: "left", color: "#212529", fontSize: "20px", fontWeight: "600", lineHeight: "24px", fontFamily: "Montserrat", marginBottom: "5px" }}>Please create SKU before proceed</h3>
                            <div className="drawer-footer" style={{ paddingTop: "10px" }}>
                                <button className="btn-save" onClick={handleSaveConfirm}>
                                    OK
                                </button>
                            </div>
                        </div>
                    </>
                )}

                <div className="employee-tabs-container">

                    {/* ─── Tab Buttons ─── */}
                    {/* <div className="tabs">
                        <button
                            className={`tab ${activeTab2 === 'edit-spu' ? 'active' : ''}`}
                            onClick={() => setActiveTab2('edit-spu')}
                        >
                            Edit SPU
                        </button>
                        <button
                            disabled={!spuid}
                            className={`tab ${activeTab2 === 'sku-variations' ? 'active' : ''} disable-tab`}
                            style={{

                                cursor: !spuid ? 'not-allowed' : 'pointer',
                            }}
                            onClick={() => setActiveTab2('sku-variations')}
                        // onClick={() => setSaveModalOpen2(true)}
                        >
                            SKU Variations
                        </button>
                        <button
                            disabled={!spuid}
                            className={`tab ${activeTab2 === 'sku-configurations' ? 'active' : ''} disable-tab`}
                            onClick={() => setActiveTab2('sku-configurations')}
                            style={{

                                cursor: !spuid ? 'not-allowed' : 'pointer',
                            }}
                        // onClick={() => setSaveModalOpen2(true)}
                        >
                            SKU Configurations
                        </button>
                        <button
                            disabled={!spuid}
                            className={`tab ${activeTab2 === 'sku-code' ? 'active' : ''} disable-tab`}

                            onClick={() => setActiveTab2('sku-code')}
                            style={{

                                cursor: !spuid ? 'not-allowed' : 'pointer',
                            }}
                        >
                            SKU Code
                        </button>
                    </div> */}
                    {saveModalOpen2 && (
                        <>
                            <div className="drawer-overlay" />
                            <div
                                className="entity-drawer modal-popup-cls"
                                ref={saveRef2}
                                style={{
                                    maxWidth: 650,
                                    margin: "0 auto",
                                    background: "white",
                                    borderRadius: 12,
                                    zIndex: 1050,
                                    padding: 24,
                                    position: "fixed",
                                    top: "50%",
                                    left: "50%",
                                    transform: "translate(-50%, -50%)",
                                    boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.2)",
                                    height: "auto",
                                    right: "auto",
                                    overflow: "inherit",
                                }}
                            >
                                <div className="drawer-header d-flex justify-content-end align-items-center pt-0 pe-0">
                                    <button className="close-btn" onClick={() => setSaveModalOpen2(false)}>
                                        <X size={20} />
                                    </button>
                                </div>
                                <h3 style={{ textAlign: "left", color: "#212529", fontSize: "20px", fontWeight: "600", lineHeight: "24px", fontFamily: "Montserrat", marginBottom: "5px" }}>The edit function implemenation</h3>
                                <div className="drawer-footer" style={{ paddingTop: "10px" }}>
                                    <button className="btn-save" onClick={handleSaveConfirm2}>
                                        OK
                                    </button>
                                </div>
                            </div>
                        </>
                    )}

                    {/* <ul style={{ color: 'red' }}>
                        {validationError && validationError.map((error, index) => (
                            <li key={index}>{error}</li>
                        ))}
                    </ul> */}
                    {activeTab2 === 'edit-spu' && (
                        <div className="tab-content" id="edit-spu-content">


                            <div className="info-section">
                                {/* ─── SPU INFO CARD ─────────────────────────────────────────── */}
                                <div className="info-card new-info-overflow-auto">
                                    <div className="info-header">
                                        <h4 className="info-title">Basic Info</h4>
                                    </div>
                                    <div className="info-content d-block">
                                        <div className='grid-info-adding'>

                                            {/* ─── ROW 1: SPU NAME & STATUS ───────────────────────────────── */}
                                            <div className='row gappingcls-added'>
                                                <div className='col-lg-6 col-md-6 col-12'>
                                                    <div className="info-inner">
                                                        <label
                                                            htmlFor="spuName"
                                                            className="form-label d-flex align-items-center gap-1"
                                                        >
                                                            SPU Name <span className='error-color'>*</span>
                                                        </label>

                                                        <input
                                                            type="text"
                                                            className={`form-control common-input-all ${errors.model_name ? 'is-invalid err-color' : ''}`}
                                                            id="spuName"
                                                            // placeholder="SPU Name"
                                                            name="model_name"
                                                            value={formData.model_name}
                                                            onChange={handleChangeWithDirty}
                                                        />

                                                        {errors.model_name && (
                                                            <div className="invalid-feedback d-block">
                                                                {errors.model_name}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>

                                                <div className='col-lg-6 col-md-6 col-12'>
                                                    <div className="info-inner">
                                                        <label htmlFor="status" className="form-label">
                                                            Status <span className='error-color'>*</span>
                                                        </label>
                                                        <div className='flexing-type-radio'>
                                                            <div className="form-check">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="radio"
                                                                    id="flexRadioDefault1"
                                                                    name="status"
                                                                    value="1"
                                                                    checked={formData.status === '1'}
                                                                    onChange={handleChangeWithDirty}
                                                                />
                                                                <label
                                                                    className="form-check-label"
                                                                    htmlFor="flexRadioDefault1"
                                                                    style={{ fontWeight: 'normal', fontSize: '14px' }}
                                                                >
                                                                    Active
                                                                </label>
                                                            </div>
                                                            <div className="form-check">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="radio"
                                                                    id="flexRadioDefault2"
                                                                    name="status"
                                                                    value="0"
                                                                    checked={formData.status === '0'}
                                                                    onChange={handleChangeWithDirty}
                                                                />
                                                                <label
                                                                    className="form-check-label"
                                                                    htmlFor="flexRadioDefault2"
                                                                    style={{ fontWeight: 'normal', fontSize: '14px' }}
                                                                >
                                                                    Inactive
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* ─── ROW 2: ID & Model Prefix  ─────────────────────────────────────── */}
                                            <div className='row gappingcls-added'>
                                                <div className='col-lg-6 col-md-6 col-12'>
                                                    <div className="info-inner">
                                                        <label
                                                            htmlFor="modelPrefix"
                                                            className="form-label d-flex align-items-center gap-1"
                                                        >
                                                            Prefix
                                                            <Tooltip title="Prefix" body="A shorter, human-friendly label for your spu">
                                                                <Info size={16} className="info-icon" />
                                                            </Tooltip>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className={`form-control common-input-all`}
                                                            id="modelPrefix"
                                                            // placeholder="Model Prefix"
                                                            name="model_prefix"
                                                            value={formData.model_prefix} onChange={handleChangeWithDirty}
                                                        />
                                                    </div>
                                                </div>
                                                <div className='col-lg-6 col-md-6 col-12'>
                                                    <div className="info-inner">
                                                        <label
                                                            htmlFor="modelPrefix"
                                                            className="form-label d-flex align-items-center gap-1"
                                                        >
                                                            ID
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="form-control common-input-all"
                                                            id="modelPrefix"
                                                            // placeholder="Model ID"
                                                            name="model_id"
                                                            value={formData.model_id} onChange={handleChangeWithDirty}
                                                        />
                                                        {errors.model_id && <p style={{ color: 'red' }}>{errors.model_id}</p>}
                                                    </div>
                                                </div>
                                            </div>

                                        </div> {/* end of grid-info-adding */}
                                    </div> {/* end of info-content */}
                                </div> {/* end of info-card */}

                                {/* ─── Product INFO CARD ─────────────────────────────────────────── */}
                                <div className="info-card new-info-overflow-auto">
                                    <div className="info-header">
                                        <h4 className="info-title">Product Info</h4>
                                    </div>
                                    <div className="info-content d-block">
                                        <div className='grid-info-adding'>
                                            {/* ─── ROW 1: Brand & Category  ────────────── */}
                                            <div className='row gappingcls-added'>

                                                <div className='col-lg-6 col-md-6 col-12'>
                                                    <MultiSelectSearch
                                                        label="Brand"
                                                        tooltip={<span className='error-color'>*</span>}
                                                        options={brands}                         // your brands
                                                        selected={
                                                            formData.brand_id
                                                                ? [brands.find(b => b.brand_id === formData.brand_id)]
                                                                : []
                                                        }
                                                        setSelected={(sel) => {
                                                            const brand = sel[0] || null;
                                                            setFormData(prev => ({ ...prev, brand_id: brand ? brand.brand_id : "" }));
                                                            setFormErrors(prev => ({ ...prev, brand_id: "" }));
                                                        }}
                                                        idKey="brand_id"
                                                        displayKey="brand_name"
                                                        logoKey="image"                           // adjust if your brand logo field is different
                                                        multiple={false}                          // SINGLE SELECT
                                                        keysToSearch={["brand_name"]}
                                                        fallbackImage={noImage}
                                                    />

                                                    {errors.brand_id && (
                                                        <div className="invalid-feedback d-block">{errors.brand_id}</div>
                                                    )}
                                                </div>


                                                <div className='col-lg-6 col-md-6 col-12'>
                                                    <div className="info-inner">
                                                        <label
                                                            htmlFor="category_id"
                                                            className="form-label d-flex align-items-center gap-1"
                                                        >
                                                            Category <span className='error-color'>*</span>
                                                        </label>

                                                        {/* Category Dropdown */}
                                                        <div style={{ position: "relative" }} ref={categoryRef}>
                                                            <div
                                                                className={`form-control common-input-all d-flex items-center cursor-pointer rounded p-2  ${errors.category_id ? 'is-invalid err-color' : ''}`}
                                                                style={{
                                                                    display: 'flex',
                                                                    justifyContent: 'space-between',
                                                                    height: '39px',
                                                                    alignItems: 'center'
                                                                }}
                                                            >
                                                                <input
                                                                    type="text"
                                                                    // placeholder="Select Category"
                                                                    value={tempParentCategorySearchTerm}
                                                                    onFocus={() => setIsCategoryOpen(true)}
                                                                    onClick={() => setIsCategoryOpen(true)}
                                                                    onChange={(e) => setTempParentCategorySearchTerm(e.target.value)}
                                                                    style={{
                                                                        flex: 1,
                                                                        border: "none",
                                                                        outline: "none",
                                                                        background: "transparent",
                                                                        fontSize: "14px"
                                                                    }}
                                                                />

                                                                <ChevronDown
                                                                    size={16}
                                                                    style={{ cursor: "pointer" }}
                                                                    onClick={() => setIsCategoryOpen(prev => !prev)}
                                                                />
                                                            </div>

                                                            {/* CATEGORY DROPDOWN */}
                                                            {isCategoryOpen && (
                                                                <div
                                                                    className="bg-white border rounded shadow-lg mt-1"
                                                                    style={{
                                                                        maxHeight: '270px',
                                                                        overflowY: 'auto',
                                                                        position: "absolute",
                                                                        left: 0,
                                                                        right: 0,
                                                                        zIndex: 1000,
                                                                    }}
                                                                >
                                                                    <div
                                                                        className="filter-options"
                                                                        style={{
                                                                            marginTop: "8px",
                                                                            border: "1px solid #e9ecef",
                                                                            borderRadius: "8px",
                                                                            maxHeight: "200px",
                                                                            overflowY: "auto",
                                                                            backgroundColor: "#fff",
                                                                            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                                                                            position: "relative",
                                                                        }}
                                                                    >
                                                                        {getUniqueParentCategories(categories)
                                                                            .filter(parent => {
                                                                                if (!tempParentCategorySearchTerm) return true;
                                                                                return parent.parent_name
                                                                                    ?.toLowerCase()
                                                                                    .includes(tempParentCategorySearchTerm.toLowerCase());
                                                                            })
                                                                            .slice(0, 10)
                                                                            .map((parent, index) => {
                                                                                const isSelected = tempSearchParentCategory.includes(parent.parent_name);

                                                                                return (
                                                                                    <div
                                                                                        key={index}
                                                                                        style={{
                                                                                            display: "flex",
                                                                                            alignItems: "center",
                                                                                            justifyContent: "space-between",
                                                                                            padding: "8px 12px",
                                                                                            cursor: "pointer",
                                                                                            fontSize: "14px",
                                                                                            backgroundColor: isSelected ? "#f8f9fa" : "transparent",
                                                                                        }}
                                                                                        onClick={() => {
                                                                                            setTempParentCategorySearchTerm(parent.parent_name);
                                                                                            setTempSearchParentCategory([parent.parent_name]);
                                                                                            setFormData(prev => ({
                                                                                                ...prev,
                                                                                                category_id: categories.find(c => c.parent_name === parent.parent_name)?.category_id
                                                                                            }));
                                                                                            setIsCategoryOpen(false);
                                                                                        }}
                                                                                    >
                                                                                        <div>
                                                                                            <div style={{ color: '#000000', fontWeight: '500' }}>
                                                                                                {parent.parent_name}
                                                                                            </div>

                                                                                            {/* Hierarchy */}
                                                                                            <div style={{ fontSize: '12px', color: '#6C757D' }}>
                                                                                                {parent.parent_parent_name
                                                                                                    ? `${parent.parent_parent_name} >> ${parent.parent_name}`
                                                                                                    : parent.parent_name}
                                                                                            </div>
                                                                                        </div>

                                                                                        {isSelected && (
                                                                                            <svg
                                                                                                xmlns="http://www.w3.org/2000/svg"
                                                                                                width="20"
                                                                                                height="20"
                                                                                                viewBox="0 0 20 20"
                                                                                                fill="none"
                                                                                            >
                                                                                                <path
                                                                                                    d="M16.6668 5L7.50016 14.1667L3.3335 10"
                                                                                                    stroke="#6C757D"
                                                                                                    strokeWidth="2"
                                                                                                    strokeLinecap="round"
                                                                                                    strokeLinejoin="round"
                                                                                                />
                                                                                            </svg>
                                                                                        )}
                                                                                    </div>
                                                                                );
                                                                            })}

                                                                        {/* No results */}
                                                                        {getUniqueParentCategories(categories)
                                                                            .filter(parent => parent.parent_name
                                                                                ?.toLowerCase()
                                                                                .includes(tempParentCategorySearchTerm.toLowerCase())
                                                                            ).length === 0 && (
                                                                                <div
                                                                                    style={{
                                                                                        padding: "12px",
                                                                                        textAlign: "center",
                                                                                        color: "#6C757D",
                                                                                        fontSize: "14px"
                                                                                    }}
                                                                                >
                                                                                    No categories found
                                                                                </div>
                                                                            )}
                                                                    </div>
                                                                </div>
                                                            )}

                                                            {errors.category_id && (
                                                                <div className="invalid-feedback d-block">
                                                                    {errors.category_id}
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>



                                            </div>
                                            {/* ─── ROW 2: Type & Release Date  ────────────── */}
                                            <div className='row gappingcls-added'>

                                                <div className='col-lg-6 col-md-6 col-12'>
                                                    <div className="info-inner">
                                                        <label
                                                            htmlFor="type"
                                                            className="form-label d-flex align-items-center gap-1"
                                                        >
                                                            Type<span className='error-color'>*</span>
                                                        </label>
                                                        <div style={{ position: "relative" }} ref={osTypeRef}>
                                                            <div
                                                                className={`form-control common-input-all d-flex justify-between items-center cursor-pointer rounded p-2 ${errors.os_type ? 'is-invalid err-color' : ''}`}
                                                                onClick={toggleOsType}
                                                                style={{ display: 'flex', justifyContent: 'space-between', height: '39px', alignContent: 'center' }}
                                                            >
                                                                <div style={{ flex: 1 }}>
                                                                    {formData.os_type || ''}
                                                                </div>

                                                                <ChevronDown size={16} />
                                                            </div>

                                                            {isOsTypeOpen && (
                                                                <div
                                                                    className="bg-white border rounded shadow-lg mt-1"
                                                                    style={{ maxHeight: '270px', overflowY: 'auto', position: "absolute", right: 0, left: 0, width: "100%", zIndex: 1 }}
                                                                >
                                                                    {/* Search box */}
                                                                    <div
                                                                        className="search-box"
                                                                        style={{
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            minWidth: '260px',
                                                                            border: '1px solid rgb(108, 117, 125)',
                                                                            borderRadius: '8px',
                                                                            background: '#fff',
                                                                            position: 'relative',
                                                                            margin: '0.5rem',
                                                                        }}
                                                                    >
                                                                        <div
                                                                            style={{
                                                                                position: 'absolute',
                                                                                left: '10px',
                                                                                display: 'flex',
                                                                                alignItems: 'center',
                                                                                height: '100%',
                                                                            }}
                                                                        >
                                                                            <Search size={20} />
                                                                        </div>
                                                                        <input
                                                                            type="text"
                                                                            style={{
                                                                                width: '100%',
                                                                                padding: '10px 10px 10px 40px',
                                                                                border: 'none',
                                                                                outline: 'none',
                                                                                background: 'transparent',
                                                                                fontSize: '14px',
                                                                            }}
                                                                            placeholder="Search types..."
                                                                            value={osTypeSearch}
                                                                            onChange={(e) => setOsTypeSearch(e.target.value)}
                                                                        />
                                                                    </div>

                                                                    {/* List items */}
                                                                    {filteredOsTypes.length > 0 ? (
                                                                        filteredOsTypes.map((type, index) => (
                                                                            <div
                                                                                key={index}
                                                                                className="p-2 hover:bg-gray-100 flex items-center cursor-pointer"
                                                                                onClick={() => handleOsTypeSelect(type)}
                                                                            >
                                                                                {type}
                                                                            </div>
                                                                        ))
                                                                    ) : (
                                                                        <div className="p-2 text-gray-500">No types found</div>
                                                                    )}
                                                                </div>
                                                            )}

                                                            {errors.os_type && (
                                                                <div className="invalid-feedback d-block">
                                                                    {errors.os_type}
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='col-lg-6 col-md-6 col-12'>
                                                    <div className="info-inner">
                                                        <label
                                                            htmlFor="release_date"
                                                            className="form-label d-flex align-items-center gap-1"
                                                        >
                                                            Release Date
                                                            <Tooltip title="Release Date" body="Human-friendly label for your entity">
                                                                <Info size={16} className="info-icon" />
                                                            </Tooltip>
                                                        </label>
                                                        <div style={{ position: "relative" }}>

                                                            {/* Date Input */}
                                                            <input
                                                                type="date"
                                                                className="form-control common-input-all"
                                                                id="release_date"
                                                                name="release_date"
                                                                placeholder=" "
                                                                value={formData.release_date || ""}
                                                                onChange={handleChangeWithDirty}
                                                                style={{
                                                                    paddingRight: "40px",    // space for your SVG
                                                                    color: formData.release_date ? "#000" : "transparent",
                                                                    WebkitTextFillColor: formData.release_date ? "#000" : "transparent"
                                                                }}
                                                            />

                                                            {/* YOUR SVG ICON */}
                                                            <div
                                                                style={{
                                                                    position: "absolute",
                                                                    right: "10px",
                                                                    top: "50%",
                                                                    transform: "translateY(-50%)",
                                                                    pointerEvents: "none"
                                                                }}
                                                                dangerouslySetInnerHTML={{
                                                                    __html: `
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" 
             viewBox="0 0 18 18" fill="none">
          <path d="M6 1.5V4.5M12 1.5V4.5M2.25 7.5H15.75M3.75 3H14.25C15.0784 3 
                   15.75 3.67157 15.75 4.5V15C15.75 15.8284 15.0784 16.5 
                   14.25 16.5H3.75C2.92157 16.5 2.25 15.8284 2.25 15V4.5C2.25 
                   3.67157 2.92157 3 3.75 3Z" 
            stroke="#6C757D" stroke-width="2" stroke-linecap="round" 
            stroke-linejoin="round"/>
        </svg>
      `
                                                                }}
                                                            />

                                                            {/* REMOVE DEFAULT CALENDAR ICON */}
                                                            <style>
                                                                {`
      input[type="date"]::-webkit-calendar-picker-indicator {
        opacity: 0 !important;
        display: none;
      }

      /* hide dd/mm/yyyy */
      input[type="date"]:placeholder-shown::-webkit-datetime-edit {
        color: transparent;
      }
      input[type="date"]:focus::-webkit-datetime-edit,
      input[type="date"]:valid::-webkit-datetime-edit {
        color: #000;
      }
    `}
                                                            </style>

                                                        </div>




                                                    </div>
                                                </div>

                                            </div>
                                            {/* ─── ROW 3: Images  ────────────── */}
                                            <div className="row gappingcls-added">
                                                <div className="col-12">
                                                    <div className="info-inner">
                                                        <label className="form-label d-flex align-items-center gap-2">
                                                            Images
                                                        </label>

                                                        {/* Dropzone */}
                                                        <div
                                                            className="upload-container"
                                                            onClick={handleBrowseClick}
                                                            onDragOver={e => e.preventDefault()}
                                                            onDragEnter={() => setIsDragging(true)}
                                                            onDragLeave={() => setIsDragging(false)}
                                                            onDrop={handleDrop}
                                                            style={{
                                                                border: '2px dashed #ccc',
                                                                borderRadius: 4,
                                                                padding: '3rem 1.5rem',
                                                                textAlign: 'center',
                                                                cursor: 'pointer',
                                                                backgroundColor: isDragging ? '#CFE2FF' : '#fff', // Drag highlight
                                                                borderColor: isDragging ? '#0D6EFD' : ( errors.uploaded_images ? 'red' : '#ccc'), // Drag highlight
                                                                transition: 'background-color 0.3s ease',
                                                            }}
                                                        >
                                                            <CloudUpload size={32} />
                                                            <p style={{ margin: 0, color: '#555', fontSize: '0.9rem' }}>
                                                                Drag your image here or{' '}
                                                                <span style={{ color: '#007bff', textDecoration: 'underline' }}>
                                                                    Browse
                                                                </span>
                                                            </p>
                                                            <input
                                                                type="file"
                                                                accept="image/*"
                                                                multiple
                                                                ref={fileInputRef}
                                                                style={{ display: 'none' }}
                                                                onChange={handleChangeWithDirty}
                                                            />
                                                        </div>

                                                        {errors.uploaded_images && (
                                                            <div className="invalid-feedback d-block">
                                                                {errors.uploaded_images}
                                                            </div>
                                                        )}

                                                        {/* Uploaded Images */}
                                                        {uploadedImages.length > 0 && (
                                                            <div className="uploaded-images mt-3">
                                                                <p className='mb-3'>
                                                                    {uploadedImages.length} Image
                                                                    {uploadedImages.length > 1 ? 's' : ''} uploaded
                                                                </p>

                                                                <ReactSortable
                                                                    list={uploadedImages}
                                                                    setList={setUploadedImages}
                                                                    handle=".drag-handle"
                                                                    tag="div"
                                                                    className="row g-2"
                                                                    chosenClass="is-dragging"    // ← this class goes on the dragged item
                                                                >
                                                                    {uploadedImages.map(img => (
                                                                        <div className="col-md-4 col-sm-6" key={img.id}>
                                                                            <div className="d-flex align-items-center justify-content-between p-2 border rounded" style={{ boxShadow: '0px 1px 4px 0px #0000001A' }}>
                                                                                <div className="d-flex align-items-center gap-2">
                                                                                    <X size={18} onClick={() => handleRemove(img.id)} className="cursor-pointer" style={{ flex: 'none' }} />
                                                                                    <img
                                                                                        src={img.preview}
                                                                                        alt="preview"
                                                                                        style={{
                                                                                            width: 40,
                                                                                            height: 40,
                                                                                            objectFit: 'cover',
                                                                                            borderRadius: 4,
                                                                                        }}
                                                                                    />
                                                                                    <div>
                                                                                        <div style={{ fontSize: '0.85rem', fontWeight: 500, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '150px', color: '#6C757D' }}>
                                                                                            {img.file.name}
                                                                                        </div>
                                                                                        <div style={{ fontSize: '0.75rem', color: '#6C757D' }}>{formatSize(img.file.size)}</div>
                                                                                    </div>
                                                                                </div>
                                                                                <Menu
                                                                                    size={16}
                                                                                    className="drag-handle text-muted"
                                                                                    style={{ cursor: 'grab', flex: 'none' }}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    ))}
                                                                </ReactSortable>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* ─── Customised Info CARD ─────────────────────────────────────────── */}
                                <div className="info-card new-info-overflow-auto main-company-body-inner">
                                    <div className="info-header"><h4 className="info-title">Customised Info {rows.length +" - "+ showMissingSku}</h4></div>
                                    <div className="info-content d-block entities-tab">
                                        <div style={{ padding: '20px', boxShadow: '0px 1px 4px #0000001A', borderRadius: '12px' }}>
                                            {rows.length === 0 && showMissingSku && (
                                                <div
                                                    className="d-flex align-items-center justify-content-between"
                                                    role="alert"
                                                    style={{
                                                        boxShadow: '0px 4px 10px 0px #0000001F',
                                                        padding: '15px 10px',
                                                        borderRadius: '12px',
                                                        border: '1px solid #DC3545',
                                                        backgroundColor: '#F8D7DA',
                                                        color: '#58151C',
                                                        fontSize: '12px',
                                                        position: 'fixed',
                                                        top: '10px',
                                                        width: 'calc(100% - 20px)',
                                                        maxWidth: '640px',
                                                        left: '50%',
                                                        transform: 'translateX(-50%)',
                                                        zIndex: 2000
                                                    }}
                                                >
                                                    <div className="d-flex align-items-center">
                                                        <Info className="me-2" />
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                                            <strong>Missing SKU:</strong> Please add a default SKU to save your SPU, or proceed to the next step
                                                        </div>
                                                    </div>

                                                    <X
                                                        size={16}
                                                        style={{ cursor: 'pointer' }}
                                                        onClick={() => setShowMissingSku(false)}
                                                    />
                                                </div>
                                            )}

                                            {(showTable || rows.length > 0) && (
                                                <div className="table-wrapper" style={{ position: 'relative', overflowX: 'auto' }}>
                                                    <table className="entities-table">
                                                        <thead>
                                                            <tr>
                                                                <th />
                                                                <th>
                                                                    Field Name <span style={{ color: "red" }}>*</span>
                                                                </th>
                                                                <th>
                                                                    Field Type <span style={{ color: "red" }}>*</span>
                                                                </th>
                                                                <th>
                                                                    Field Value <span style={{ color: "red" }}>*</span>
                                                                </th>
                                                                <th />
                                                            </tr>
                                                        </thead>


                                                        <ReactSortable list={rows} setList={setRows} handle=".drag-handle" tag="tbody">
                                                            {rows.map((r, idx) => {
                                                                if (!rowRefs.current[r.id]) rowRefs.current[r.id] = React.createRef();
                                                                const ref = rowRefs.current[r.id];
                                                                return <EntityRow key={r.id} refNode={ref} rowState={r} index={idx}
                                                                    deleteRow={deleteRow} updateRowBulk={updateRowBulk} />;
                                                            })}
                                                        </ReactSortable>
                                                    </table>
                                                </div>
                                            )}
                                            <div className="edit-organisation-info" style={{ display: 'flex', marginBottom: '0', boxShadow: 'none', padding: '0' }}>
                                                {/* <button onClick={addRow} className="dark-button" disabled={isAddCustomDisabled}>Add Fields</button> */}
                                                <button
                                                    onClick={() => {
                                                        if (!showTable) setShowTable(true);
                                                        addRow();
                                                    }}
                                                    className="dark-button"
                                                    disabled={isAddCustomDisabled}
                                                >
                                                    Add Fields
                                                </button>

                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* ─── ADDITIONAL INFO CARD ─────────────────────────────────────────── */}
                                <div className="info-card">
                                    <div className="info-header">
                                        <h4 className="info-title">Additional Info</h4>
                                    </div>
                                    <div className="info-content">
                                        <div className="info-inner common-textarea">
                                            <label
                                                htmlFor="exampleFormControlTextarea1"
                                                className="form-label"
                                            >
                                                Note
                                            </label>
                                            <textarea
                                                className="form-control w-100 common-textarea-all"
                                                id="exampleFormControlTextarea1"
                                                rows="3"
                                                name="notes"
                                                value={formData.notes} onChange={handleChangeWithDirty}
                                            ></textarea>

                                        </div>
                                    </div>
                                </div>
                            </div> {/* end of info-section */}
                        </div>
                    )}
                    {activeTab2 === 'sku-variations' && (
                        <div className="tab-content" id="sku-variations-content">
                            <div className="info-section">
                                {/* ─── SKU Variations CARD ─────────────────────────────────────────── */}
                                <div className="info-card new-info-overflow-auto main-company-body-inner">
                                    {/* <div className="info-header"><h4 className="info-title">SKU Variations</h4></div> */}
                                    <div className="info-content d-block entities-tab">
                                        <div style={{ padding: '20px', boxShadow: '0px 1px 4px #0000001A', borderRadius: '12px' }}>
                                            {rows2.length === 0 && showMissingVar && (
                                                <div
                                                    className="d-flex align-items-center justify-content-between"
                                                    role="alert"
                                                    style={{
                                                        boxShadow: '0px 4px 10px 0px #0000001F',
                                                        padding: '15px 10px',
                                                        borderRadius: '12px',
                                                        border: '1px solid #DC3545',
                                                        backgroundColor: '#F8D7DA',
                                                        color: '#58151C',
                                                        fontSize: '12px',
                                                        position: 'fixed',
                                                        top: '10px',
                                                        width: 'calc(100% - 20px)',
                                                        maxWidth: '640px',
                                                        left: '50%',
                                                        transform: 'translateX(-50%)',
                                                        zIndex: 2000
                                                    }}
                                                >
                                                    <div className="d-flex align-items-center">
                                                        <Info className="me-2" />
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                                            <strong>Missing SKU</strong> —— Please add a default SKU to save your SPU, or proceed to the next step
                                                        </div>
                                                    </div>

                                                    <X size={16} style={{ cursor: 'pointer' }} onClick={() => setShowMissingVar(false)} />
                                                </div>
                                            )}


                                            <div className="table-wrapper" style={{ position: 'relative', overflowX: 'auto' }}>
                                                <table className="entities-table tab-table w-100">
                                                    <thead height="45px">
                                                        <tr>
                                                            <th />
                                                            <SortableHeader
                                                                label="SKU Variation"
                                                                field="skuVariation"
                                                                sortField={sortField}
                                                                sortOrder={sortOrder}
                                                                handleSort={handleSort}
                                                            />
                                                            <SortableHeader
                                                                label="Variation Options"
                                                                field="variationOptions"
                                                                sortField={sortField}
                                                                sortOrder={sortOrder}
                                                                handleSort={handleSort}
                                                            />

                                                            <th /></tr>
                                                    </thead>
                                                    <ReactSortable list={rows2} setList={setRows2} handle=".drag-handle" tag="tbody">
                                                        {rows2?.length ? rows2.map((r, idx) => {
                                                            if (!rowRefs2.current[r.id]) rowRefs2.current[r.id] = React.createRef();
                                                            return (
                                                                <VariationRow
                                                                    key={r.id}
                                                                    refNode={rowRefs2.current[r.id]}
                                                                    rowState={r}
                                                                    // index={idx}
                                                                    deleteRow={deleteRow2}
                                                                    updateRow={updateRow2}
                                                                    skuAttributes={skuAttributes}
                                                                    skuAttributeOptions={skuAttributeOptions}
                                                                    rows2={rows2 || []} // Ensure rows2 is always an array
                                                                />
                                                            );
                                                        }) : null}
                                                    </ReactSortable>
                                                </table>
                                            </div>
                                            <div className="edit-organisation-info" style={{ display: 'flex', marginTop: '20px', marginBottom: '0', boxShadow: 'none', padding: '0' }}>
                                                <button onClick={addRow2} className="dark-button" disabled={isAddVariationDisabled}>Add SKU</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    {archivedModalOpen && (
                        <>
                            {/* Overlay */}
                            <div className="drawer-overlay" />

                            <div
                                className="entity-drawer modal-popup-cls"
                                ref={archivedRef}
                                style={{
                                    maxWidth: 650,
                                    margin: "0 auto",
                                    background: "white",
                                    borderRadius: 12,
                                    zIndex: 1050,
                                    padding: 24,
                                    position: "fixed",
                                    top: "50%",
                                    left: "50%",
                                    transform: "translate(-50%, -50%)",
                                    boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.2)",
                                    height: "auto",
                                    right: "auto",
                                    overflow: "inherit",
                                }}
                            >
                                <div className="drawer-header d-flex justify-content-end align-items-center pt-0 pe-0">
                                    <button className="close-btn" onClick={() => setArchivedModalOpen(false)}>
                                        <X size={20} />
                                    </button>
                                </div>

                                <h3 style={{
                                    textAlign: "left", color: "#212529", fontSize: "20px",
                                    fontWeight: "600", lineHeight: "24px", fontFamily: "Montserrat",
                                    marginBottom: "5px"
                                }}>The SPU can’t be archived</h3>

                                <p style={{
                                    marginBottom: "0", textAlign: "left", color: "#6C757D",
                                    fontSize: "14px", fontWeight: "400", lineHeight: "20px",
                                    fontFamily: "Montserrat"
                                }}>
                                    This SPU can’t be archived because it’s referenced by one or more SPUs.
                                    Please remove or reassign those SPUs before archiving.
                                </p>

                                <div className="drawer-footer" style={{ paddingTop: "10px" }}>
                                    <button className="btn-save" onClick={handleArchivedConfirm}>
                                        OK
                                    </button>
                                </div>
                            </div>
                        </>
                    )}

                    {activeTab2 === 'sku-configurations' && (
                        <div className="tab-content" id="sku-configurations-content">
                            <div className="info-section">
                                {/* ─── SKU Configurations CARD ─────────────────────────────────────────── */}
                                <div className="info-card new-info-overflow-auto main-company-body-inner">
                                    {/* <div className="info-header"><h4 className="info-title">Configuration List</h4></div> */}
                                    <div className="info-content d-block entities-tab">
                                        <div style={{ padding: '20px', boxShadow: '0px 1px 4px #0000001A', borderRadius: '12px' }}>
                                            {showCfgExists && (
                                                <div
                                                    className="d-flex align-items-center justify-content-between"
                                                    role="alert"
                                                    style={{
                                                        boxShadow: '0px 4px 10px 0px #0000001F',
                                                        padding: '15px 10px',
                                                        borderRadius: '12px',
                                                        border: '1px solid #DC3545',
                                                        backgroundColor: '#F8D7DA',
                                                        color: '#58151C',
                                                        fontSize: '12px',
                                                        position: 'fixed',
                                                        top: '10px',
                                                        width: 'calc(100% - 20px)',
                                                        maxWidth: '535px',
                                                        left: '50%',
                                                        transform: 'translateX(-50%)',
                                                        zIndex: 2000
                                                    }}
                                                >
                                                    <div className="d-flex align-items-center">
                                                        <Info className="me-2" />
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                                            <strong>Configuration Exists:</strong> Please choose different variant combinations
                                                        </div>
                                                    </div>
                                                    <X
                                                        size={16}
                                                        style={{ cursor: 'pointer' }}
                                                        onClick={() => setShowCfgExists(false)}
                                                    />
                                                </div>
                                            )}
                                            {configError && (
                                                <div
                                                    className="d-flex align-items-center justify-content-between"
                                                    role="alert"
                                                    style={{
                                                        boxShadow: '0px 4px 10px 0px #0000001F',
                                                        padding: '15px 10px',
                                                        borderRadius: '12px',
                                                        border: '1px solid #DC3545',
                                                        backgroundColor: '#F8D7DA',
                                                        color: '#58151C',
                                                        fontSize: '12px',
                                                        position: 'fixed',
                                                        top: '10px',
                                                        width: 'calc(100% - 20px)',
                                                        maxWidth: '640px',
                                                        left: '50%',
                                                        transform: 'translateX(-50%)',
                                                        zIndex: 2000,
                                                    }}
                                                >
                                                    <div className="d-flex align-items-center">
                                                        <Info className="me-2" />
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                                            <strong>Error:</strong> {configError}
                                                        </div>
                                                    </div>
                                                    <X
                                                        size={16}
                                                        style={{ cursor: 'pointer' }}
                                                        onClick={() => setConfigError('')}
                                                    />
                                                </div>
                                            )}
                                            {rows3.length === 0 && showMissingCfg && (
                                                <div
                                                    className="d-flex align-items-center justify-content-between"
                                                    role="alert"
                                                    style={{
                                                        boxShadow: '0px 4px 10px 0px #0000001F',
                                                        padding: '15px 10px',
                                                        borderRadius: '12px',
                                                        border: '1px solid #FFC107',
                                                        backgroundColor: '#FFF3CD',
                                                        color: '#664D03',
                                                        fontSize: '12px',
                                                        position: 'fixed',
                                                        top: '10px',
                                                        width: 'calc(100% - 20px)',
                                                        maxWidth: '640px',
                                                        left: '50%',
                                                        transform: 'translateX(-50%)',
                                                        zIndex: 2000
                                                    }}
                                                >
                                                    <div className="d-flex align-items-center">
                                                        <Info className="me-2" />
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                                            <strong>Missing Configuration:</strong> Please add a configuration to proceed
                                                        </div>
                                                    </div>
                                                    <X
                                                        size={16}
                                                        style={{ cursor: 'pointer' }}
                                                        onClick={() => setShowMissingCfg(false)}
                                                    />
                                                </div>
                                            )}
                                            <div className="table-wrapper" style={{ position: 'relative', overflowX: 'auto' }}>
                                                <table className="entities-table tab-table w-100">
                                                    <thead height="35px">
                                                        <tr>
                                                            <th />

                                                            <th>
                                                                <span
                                                                    style={{
                                                                        fontFamily: "Montserrat",
                                                                        fontSize: "12px",
                                                                        fontWeight: 700,
                                                                        fontStyle: "normal",
                                                                        color: "#212529",
                                                                        display: "flex",
                                                                        // alignItems: "center",
                                                                        lineHeight: "normal",
                                                                    }}
                                                                >
                                                                    Configuration Name <span style={{ color: "#DC3545" }}>*</span>
                                                                </span>
                                                            </th>

                                                            <th>
                                                                <span
                                                                    style={{
                                                                        fontFamily: "Montserrat",
                                                                        fontSize: "12px",
                                                                        fontWeight: 700,
                                                                        color: "#212529",
                                                                        display: "flex",
                                                                        // alignItems: "center",
                                                                        lineHeight: "normal",
                                                                        fontStyle: "normal",
                                                                    }}
                                                                >
                                                                    Configuration Options <span style={{ color: "#DC3545" }}>*</span>
                                                                </span>
                                                            </th>

                                                            <th />
                                                        </tr>
                                                    </thead>
                                                    <ReactSortable list={rows3} setList={setRows3} handle=".drag-handle" tag="tbody">
                                                        {rows3.map((r, idx) => {
                                                            if (!rowRefs3.current[r.id]) rowRefs3.current[r.id] = React.createRef();
                                                            return (
                                                                <ConfigRow
                                                                    // key={r.id}
                                                                    refNode={rowRefs3.current[r.id]}
                                                                    rowState={r}
                                                                    index={idx}
                                                                    deleteRow={deleteRow3}
                                                                    updateRow={updateRow3}
                                                                    rows2={rows2}
                                                                    skuAttributes={skuAttributes}
                                                                />
                                                            );
                                                        })}
                                                    </ReactSortable>
                                                </table>
                                            </div>
                                            <div className="edit-organisation-info" >
                                                <button onClick={addRow3} className="dark-button" style={{ display: 'flex', height: '34px', minWidth: '100px', padding: '10px', justifyContent: 'center', alignItems: 'center', gap: '10px', borderRadius: '8px', fontSize: '12px', fontFamily: 'Montserrat', fontStyle: 'normal', fontWeight: '600', lineHeight: 'normal', border: '1px solid #212529', }} disabled={isAddConfigDisabled}>Add Configurations</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* ─── Product Info CARD ─────────────────────────────────────────── */}
                                <div className="info-card new-info-overflow-auto main-company-body-inner">
                                    <div className="info-content d-block entities-tab">
                                        <div className="pt-container">
                                            <div className="tabs-wrapper">
                                                <div className="tabs" ref={containerRef}>
                                                    {productTabs
                                                        .filter(t => !overflowTabs.includes(t.key))
                                                        .map(tab => (
                                                            <button
                                                                key={tab.key}
                                                                ref={el => el && (tabRefs.current[tab.key] = el)}
                                                                className={`tab ${activeTab === tab.key ? "active" : ""}`}
                                                                onClick={() => {
                                                                    setActiveTab(tab.key);
                                                                    setMenuOpen(false);
                                                                }}
                                                            >
                                                                {tab.label}
                                                            </button>
                                                        ))}
                                                </div>

                                                {/* <button
                                                    ref={triggerRef}
                                                    className={`tab-trigger ${menuOpen ? "active" : ""}`}
                                                    onClick={toggleMenu}
                                                >
                                                    <ChevronDown className="h-5 w-5" />
                                                </button> */}
                                            </div>

                                            {/* portal menu */}
                                            {portalMenu}

                                            {/* your tab contents */}
                                            <div className="tab-content" style={{ marginTop: '20px' }}>
                                                {productTabs.length > 0 ? (
                                                    productTabs.map(tab => (
                                                        <div key={tab.key} style={{ display: activeTab === tab.key ? 'block' : 'none' }}>
                                                            <div className='grid-info-adding' style={{
                                                                width: "100%",
                                                                maxWidth: "100%",
                                                                overflowX: "auto",
                                                                boxSizing: "border-box",

                                                            }}>

                                                                {/* ─── ROW 3: Images  ────────────── */}
                                                                <div className="row gappingcls-added">
                                                                    <div className="col-12">
                                                                        <div className="info-inner">
                                                                            <label className="form-label d-flex align-items-center gap-2">
                                                                                Images
                                                                            </label>

                                                                            {/* Upload Container Wrapper */}
                                                                            <div style={{ width: "100%", maxWidth: "100%", boxSizing: "border-box" }}>

                                                                                {/* UPLOAD CONTAINER */}
                                                                                <div
                                                                                    className="upload-container"
                                                                                    onClick={() => {
                                                                                        const input = document.createElement('input');
                                                                                        input.type = 'file';
                                                                                        input.accept = 'image/*';
                                                                                        input.multiple = true;
                                                                                        input.onchange = (e) => handleConfigImageChange(e, tab.key);
                                                                                        input.click();
                                                                                    }}
                                                                                    onDragOver={(e) => e.preventDefault()}
                                                                                    onDragEnter={() => setIsDragging(true)}
                                                                                    onDragLeave={() => setIsDragging(false)}
                                                                                    onDrop={(e) => handleConfigDrop(e, tab.key)}
                                                                                    style={{
                                                                                        /* FIXED upload box behavior */
                                                                                        width: "100%",
                                                                                        maxWidth: "100%",
                                                                                        boxSizing: "border-box",

                                                                                        border: "2px dashed #ccc",
                                                                                        borderRadius: 4,
                                                                                        padding: "1.5rem",

                                                                                        display: "flex",
                                                                                        flexDirection: "column",
                                                                                        justifyContent: "center",
                                                                                        alignItems: "center",

                                                                                        minHeight: "120px", // ⭐ FIXED HEIGHT
                                                                                        textAlign: "center",
                                                                                        cursor: "pointer",

                                                                                        backgroundColor: isDragging ? "#CFE2FF" : "#fff",
                                                                                        borderColor: isDragging ? "#0D6EFD" : "#ccc",
                                                                                        transition: "background-color 0.3s ease, border-color 0.3s ease",
                                                                                    }}
                                                                                >
                                                                                    {/* ICON */}
                                                                                    <CloudUpload size={32} style={{ marginBottom: "0.5rem" }} />

                                                                                    {/* TEXT */}
                                                                                    <p style={{ margin: 0, color: "#555", fontSize: "0.9rem" }}>
                                                                                        Drag your image here or{" "}
                                                                                        <span style={{ color: "#007bff", textDecoration: "underline" }}>
                                                                                            Browse
                                                                                        </span>
                                                                                    </p>
                                                                                </div>
                                                                            </div>

                                                                            {/* Uploaded Images Preview */}
                                                                            {configImages[tab.key]?.length > 0 && (
                                                                                <div className="uploaded-images mt-3">
                                                                                    <p className="mb-3">
                                                                                        {configImages[tab.key].length} Image
                                                                                        {configImages[tab.key].length > 1 ? "s" : ""} uploaded
                                                                                    </p>

                                                                                    <ReactSortable
                                                                                        list={configImages[tab.key] || []}
                                                                                        setList={(newList) =>
                                                                                            setConfigImages((prev) => ({
                                                                                                ...prev,
                                                                                                [tab.key]: newList.map((img) => ({
                                                                                                    ...img,
                                                                                                    spuId: img.spuId || spuid,
                                                                                                    skuIdentifier: img.skuIdentifier || tab.key,
                                                                                                })),
                                                                                            }))
                                                                                        }
                                                                                        handle=".drag-handle"
                                                                                        tag="div"
                                                                                        className="row g-2"
                                                                                        chosenClass="is-dragging"
                                                                                    >
                                                                                        {(configImages[tab.key] || []).map((img) => (
                                                                                            <div className="col-md-4 col-sm-6" key={img.id}>
                                                                                                <div
                                                                                                    className="d-flex align-items-center justify-content-between p-2 border rounded"
                                                                                                    style={{ boxShadow: "0px 1px 4px 0px #0000001A" }}
                                                                                                >
                                                                                                    <div className="d-flex align-items-center gap-2">
                                                                                                        <X
                                                                                                            size={18}
                                                                                                            onClick={() => handleConfigRemove(img.id, tab.key)}
                                                                                                            className="cursor-pointer"
                                                                                                            style={{ flex: "none" }}
                                                                                                        />
                                                                                                        <img
                                                                                                            src={img.preview}
                                                                                                            alt="preview"
                                                                                                            style={{
                                                                                                                width: 40,
                                                                                                                height: 40,
                                                                                                                objectFit: "cover",
                                                                                                                borderRadius: 4,
                                                                                                            }}
                                                                                                        />
                                                                                                        <div>
                                                                                                            <div
                                                                                                                style={{
                                                                                                                    fontSize: "0.85rem",
                                                                                                                    fontWeight: 500,
                                                                                                                    whiteSpace: "nowrap",
                                                                                                                    overflow: "hidden",
                                                                                                                    textOverflow: "ellipsis",
                                                                                                                    maxWidth: "150px",
                                                                                                                    color: "#6C757D",
                                                                                                                }}
                                                                                                            >
                                                                                                                {img.file.name}
                                                                                                            </div>
                                                                                                            <div style={{ fontSize: "0.75rem", color: "#6C757D" }}>
                                                                                                                {formatSize(img.file.size)}
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    </div>

                                                                                                    <Menu
                                                                                                        size={16}
                                                                                                        className="drag-handle text-muted"
                                                                                                        style={{ cursor: "grab", flex: "none" }}
                                                                                                    />
                                                                                                </div>
                                                                                            </div>
                                                                                        ))}
                                                                                    </ReactSortable>
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                    <UnsavedChangesPrompt isDirty={isDirty} />
                                                                </div>
                                                                {/* ─── Customised Info ────────────── */}
                                                                <div className="row gappingcls-added" style={{ marginTop: '20px' }}>
                                                                    <div className="col-12">
                                                                        <div className="info-inner">
                                                                            <label className="form-label d-flex align-items-center gap-2">
                                                                                Customised Info
                                                                            </label>
                                                                            <div className="info-content d-block entities-tab" style={{ padding: '0' }}>
                                                                                <div style={{ padding: '20px', boxShadow: '0px 1px 4px #0000001A', borderRadius: '12px' }}>
                                                                                    {rows.length === 0 && showMissingSku && (
                                                                                        <div
                                                                                            className="d-flex align-items-center justify-content-between"
                                                                                            role="alert"
                                                                                            style={{
                                                                                                boxShadow: '0px 4px 10px 0px #0000001F',
                                                                                                padding: '15px 10px',
                                                                                                borderRadius: '12px',
                                                                                                border: '1px solid #DC3545',
                                                                                                backgroundColor: '#F8D7DA',
                                                                                                color: '#58151C',
                                                                                                fontSize: '12px',
                                                                                                position: 'fixed',
                                                                                                top: '10px',
                                                                                                width: 'calc(100% - 20px)',
                                                                                                maxWidth: '640px',
                                                                                                left: '50%',
                                                                                                transform: 'translateX(-50%)',
                                                                                                zIndex: 2000
                                                                                            }}
                                                                                        >
                                                                                            <div className="d-flex align-items-center">
                                                                                                <Info className="me-2" />
                                                                                                <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                                                                                    <strong>Missing SKU:</strong> Please add a default SKU to save your SPU, or proceed to the next step
                                                                                                </div>
                                                                                            </div>
                                                                                            <X
                                                                                                size={16}
                                                                                                style={{ cursor: 'pointer' }}
                                                                                                onClick={() => setShowMissingSku(false)}
                                                                                            />
                                                                                        </div>
                                                                                    )}
                                                                                    <div className="table-wrapper" style={{ position: 'relative', overflowX: 'auto' }}>
                                                                                        <table className="entities-table tab-table w-100">
                                                                                            <thead>
                                                                                                <tr>
                                                                                                    <th />
                                                                                                    <th>
                                                                                                        <span
                                                                                                            style={{
                                                                                                                fontFamily: "Montserrat",
                                                                                                                fontSize: "12px",
                                                                                                                fontWeight: 700,
                                                                                                                fontStyle: "normal",
                                                                                                                color: "#212529",
                                                                                                                display: "flex",
                                                                                                                // alignItems: "center",
                                                                                                                lineHeight: "normal",
                                                                                                            }}
                                                                                                        >
                                                                                                            Field Name <span style={{ color: "#DC3545" }}>*</span>
                                                                                                        </span>
                                                                                                    </th>

                                                                                                    <th>
                                                                                                        <span
                                                                                                            style={{
                                                                                                                fontFamily: "Montserrat",
                                                                                                                fontSize: "12px",
                                                                                                                fontWeight: 700,
                                                                                                                color: "#212529",
                                                                                                                display: "flex",
                                                                                                                // alignItems: "center",
                                                                                                                lineHeight: "normal",
                                                                                                                fontStyle: "normal",
                                                                                                            }}
                                                                                                        >
                                                                                                            Field Type <span style={{ color: "#DC3545" }}>*</span>
                                                                                                        </span>
                                                                                                    </th>
                                                                                                    <th>
                                                                                                        <span
                                                                                                            style={{
                                                                                                                fontFamily: "Montserrat",
                                                                                                                fontSize: "12px",
                                                                                                                fontWeight: 700,
                                                                                                                color: "#212529",
                                                                                                                display: "flex",
                                                                                                                // alignItems: "center",
                                                                                                                lineHeight: "normal",
                                                                                                                fontStyle: "normal",
                                                                                                            }}
                                                                                                        >
                                                                                                            Field Value  <span style={{ color: "#DC3545" }}>*</span>
                                                                                                        </span>
                                                                                                    </th>
                                                                                                    <th />
                                                                                                </tr>
                                                                                            </thead>
                                                                                            <ReactSortable list={rows} setList={setRows} handle=".drag-handle" tag="tbody">
                                                                                                {rows.map((r, idx) => {
                                                                                                    if (!rowRefs.current[r.id]) rowRefs.current[r.id] = React.createRef();
                                                                                                    const ref = rowRefs.current[r.id];
                                                                                                    return <EntityRow key={r.id} refNode={ref} rowState={r} index={idx}
                                                                                                        deleteRow={deleteRow} updateRowBulk={updateRowBulk} />;
                                                                                                })}
                                                                                            </ReactSortable>
                                                                                        </table>
                                                                                    </div>
                                                                                    <div className="edit-organisation-info" style={{ display: 'flex', marginTop: '20px', marginBottom: '0', boxShadow: 'none', padding: '0' }}>
                                                                                        <button onClick={addRow} className="dark-button" disabled={isAddCustomDisabled}>Add Fields</button>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="info-content" style={{ padding: "20px 0" }}>
                                                                                    <div className="info-inner common-textarea">
                                                                                        <label className="form-label d-flex align-items-center gap-2">
                                                                                            Note
                                                                                        </label>
                                                                                        <textarea
                                                                                            className="form-control w-100 common-textarea-all"
                                                                                            id="exampleFormControlTextarea1"
                                                                                            rows="3"
                                                                                            name="notes"
                                                                                            value={formData.notes}
                                                                                            onChange={handleChangeWithDirty}
                                                                                            style={{ border: '1px solid #6C757D' }}
                                                                                        ></textarea>
                                                                                    </div>
                                                                                </div>

                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))
                                                ) : (
                                                    <div>No configurations available</div>
                                                )}
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {activeTab2 === 'sku-code' && (
                        <div className="tab-content" id="sku-code-content">
                            <div className="info-section">
                                {/* ─── SKU Code CARD ─────────────────────────────────────────── */}
                                <div className="info-card new-info-overflow-auto main-company-body-inner">
                                    {/* <div className="info-header"><h4 className="info-title">SKU Code</h4></div> */}
                                    <div className="info-content d-block entities-tab">
                                        <div className="table-wrapper" style={{ position: 'relative', overflowX: 'auto' }}>
                                            <table className="entities-table tab-table w-100">
                                                <thead>
                                                    <tr>
                                                        <th><span>SKU Spec </span></th>

                                                        <SortableHeader
                                                            label={<span>SKU Name <span style={{ color: "red" }}>*</span></span>}
                                                            field="specName"
                                                            sortField={sortField}
                                                            sortOrder={sortOrder}
                                                            handleSort={handleSort}
                                                        />
                                                        <SortableHeader
                                                            label={<span>SKU Code <span style={{ color: "red" }}>*</span>
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                                                                    <g clip-path="url(#clip0_4743_12572)">
                                                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M5 9.375C6.16032 9.375 7.27312 8.91406 8.09359 8.09359C8.91406 7.27312 9.375 6.16032 9.375 5C9.375 3.83968 8.91406 2.72688 8.09359 1.90641C7.27312 1.08594 6.16032 0.625 5 0.625C3.83968 0.625 2.72688 1.08594 1.90641 1.90641C1.08594 2.72688 0.625 3.83968 0.625 5C0.625 6.16032 1.08594 7.27312 1.90641 8.09359C2.72688 8.91406 3.83968 9.375 5 9.375ZM5 10C6.32608 10 7.59785 9.47322 8.53553 8.53553C9.47322 7.59785 10 6.32608 10 5C10 3.67392 9.47322 2.40215 8.53553 1.46447C7.59785 0.526784 6.32608 0 5 0C3.67392 0 2.40215 0.526784 1.46447 1.46447C0.526784 2.40215 0 3.67392 0 5C0 6.32608 0.526784 7.59785 1.46447 8.53553C2.40215 9.47322 3.67392 10 5 10Z" fill="#5E6E82" />
                                                                        <path d="M5.58122 4.11719L4.14997 4.29656L4.09872 4.53406L4.37997 4.58594C4.56372 4.62969 4.59997 4.69594 4.55997 4.87906L4.09872 7.04656C3.97747 7.60719 4.16435 7.87094 4.60372 7.87094C4.94435 7.87094 5.33997 7.71344 5.51935 7.49719L5.57434 7.23719C5.44934 7.34719 5.26684 7.39094 5.14559 7.39094C4.97372 7.39094 4.91122 7.27031 4.95559 7.05781L5.58122 4.11719Z" fill="#5E6E82" />
                                                                        <path d="M5 3.4375C5.34518 3.4375 5.625 3.15768 5.625 2.8125C5.625 2.46732 5.34518 2.1875 5 2.1875C4.65482 2.1875 4.375 2.46732 4.375 2.8125C4.375 3.15768 4.65482 3.4375 5 3.4375Z" fill="#5E6E82" />
                                                                    </g>
                                                                    <defs>
                                                                        <clipPath id="clip0_4743_12572">
                                                                            <rect width="10" height="10" fill="white" />
                                                                        </clipPath>
                                                                    </defs>
                                                                </svg>
                                                            </span>}
                                                            field="skuCode"
                                                            sortField={sortField}
                                                            sortOrder={sortOrder}
                                                            handleSort={handleSort}
                                                        />

                                                        <SortableHeader
                                                            label={<span>Enable <span style={{ color: "red" }}>*</span></span>}
                                                            field="skuCode"
                                                            sortField={sortField}
                                                            sortOrder={sortOrder}
                                                            handleSort={handleSort}
                                                        />

                                                        <SortableHeader
                                                            label={<span>GTIN <span style={{ color: "red" }}>*</span>
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                                                                    <g clip-path="url(#clip0_4743_12572)">
                                                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M5 9.375C6.16032 9.375 7.27312 8.91406 8.09359 8.09359C8.91406 7.27312 9.375 6.16032 9.375 5C9.375 3.83968 8.91406 2.72688 8.09359 1.90641C7.27312 1.08594 6.16032 0.625 5 0.625C3.83968 0.625 2.72688 1.08594 1.90641 1.90641C1.08594 2.72688 0.625 3.83968 0.625 5C0.625 6.16032 1.08594 7.27312 1.90641 8.09359C2.72688 8.91406 3.83968 9.375 5 9.375ZM5 10C6.32608 10 7.59785 9.47322 8.53553 8.53553C9.47322 7.59785 10 6.32608 10 5C10 3.67392 9.47322 2.40215 8.53553 1.46447C7.59785 0.526784 6.32608 0 5 0C3.67392 0 2.40215 0.526784 1.46447 1.46447C0.526784 2.40215 0 3.67392 0 5C0 6.32608 0.526784 7.59785 1.46447 8.53553C2.40215 9.47322 3.67392 10 5 10Z" fill="#5E6E82" />
                                                                        <path d="M5.58122 4.11719L4.14997 4.29656L4.09872 4.53406L4.37997 4.58594C4.56372 4.62969 4.59997 4.69594 4.55997 4.87906L4.09872 7.04656C3.97747 7.60719 4.16435 7.87094 4.60372 7.87094C4.94435 7.87094 5.33997 7.71344 5.51935 7.49719L5.57434 7.23719C5.44934 7.34719 5.26684 7.39094 5.14559 7.39094C4.97372 7.39094 4.91122 7.27031 4.95559 7.05781L5.58122 4.11719Z" fill="#5E6E82" />
                                                                        <path d="M5 3.4375C5.34518 3.4375 5.625 3.15768 5.625 2.8125C5.625 2.46732 5.34518 2.1875 5 2.1875C4.65482 2.1875 4.375 2.46732 4.375 2.8125C4.375 3.15768 4.65482 3.4375 5 3.4375Z" fill="#5E6E82" />
                                                                    </g>
                                                                    <defs>
                                                                        <clipPath id="clip0_4743_12572">
                                                                            <rect width="10" height="10" fill="white" />
                                                                        </clipPath>
                                                                    </defs>
                                                                </svg>
                                                            </span>}
                                                            field="gtin"
                                                            sortField={sortField}
                                                            sortOrder={sortOrder}
                                                            handleSort={handleSort}
                                                        />

                                                        <SortableHeader
                                                            label={<span>MSRP <span style={{ color: "red" }}>*</span>
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                                                                    <g clip-path="url(#clip0_4743_12572)">
                                                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M5 9.375C6.16032 9.375 7.27312 8.91406 8.09359 8.09359C8.91406 7.27312 9.375 6.16032 9.375 5C9.375 3.83968 8.91406 2.72688 8.09359 1.90641C7.27312 1.08594 6.16032 0.625 5 0.625C3.83968 0.625 2.72688 1.08594 1.90641 1.90641C1.08594 2.72688 0.625 3.83968 0.625 5C0.625 6.16032 1.08594 7.27312 1.90641 8.09359C2.72688 8.91406 3.83968 9.375 5 9.375ZM5 10C6.32608 10 7.59785 9.47322 8.53553 8.53553C9.47322 7.59785 10 6.32608 10 5C10 3.67392 9.47322 2.40215 8.53553 1.46447C7.59785 0.526784 6.32608 0 5 0C3.67392 0 2.40215 0.526784 1.46447 1.46447C0.526784 2.40215 0 3.67392 0 5C0 6.32608 0.526784 7.59785 1.46447 8.53553C2.40215 9.47322 3.67392 10 5 10Z" fill="#5E6E82" />
                                                                        <path d="M5.58122 4.11719L4.14997 4.29656L4.09872 4.53406L4.37997 4.58594C4.56372 4.62969 4.59997 4.69594 4.55997 4.87906L4.09872 7.04656C3.97747 7.60719 4.16435 7.87094 4.60372 7.87094C4.94435 7.87094 5.33997 7.71344 5.51935 7.49719L5.57434 7.23719C5.44934 7.34719 5.26684 7.39094 5.14559 7.39094C4.97372 7.39094 4.91122 7.27031 4.95559 7.05781L5.58122 4.11719Z" fill="#5E6E82" />
                                                                        <path d="M5 3.4375C5.34518 3.4375 5.625 3.15768 5.625 2.8125C5.625 2.46732 5.34518 2.1875 5 2.1875C4.65482 2.1875 4.375 2.46732 4.375 2.8125C4.375 3.15768 4.65482 3.4375 5 3.4375Z" fill="#5E6E82" />
                                                                    </g>
                                                                    <defs>
                                                                        <clipPath id="clip0_4743_12572">
                                                                            <rect width="10" height="10" fill="white" />
                                                                        </clipPath>
                                                                    </defs>
                                                                </svg>
                                                            </span>}
                                                            field="gtin"
                                                            sortField={sortField}
                                                            sortOrder={sortOrder}
                                                            handleSort={handleSort}
                                                        />


                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    {skuCodeRows.map((row, idx) => (
                                                        <tr key={row.id}>
                                                            <td>
                                                                <div style={{
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    flexWrap: 'wrap',
                                                                    minHeight: '40px',
                                                                    gap: '10px',
                                                                    minWidth: '350px',
                                                                    maxWidth: '350px'
                                                                }}>
                                                                    {row.specs.map((item, i) => (
                                                                        <div key={i}>
                                                                            <span style={{
                                                                                color: '#212529',
                                                                                fontSize: '12px',
                                                                                lineHeight: '15px',
                                                                                fontWeight: '400',
                                                                                marginBottom: '5px',
                                                                                display: 'block',
                                                                            }}>
                                                                                {item.group}
                                                                            </span>
                                                                            <span style={{
                                                                                backgroundColor: '#FFEB00',
                                                                                color: '#212529',
                                                                                borderRadius: '16px',
                                                                                padding: '4px 8px',
                                                                                display: 'flex',
                                                                                alignItems: 'center',
                                                                                justifyContent: 'center',
                                                                                fontSize: '12px',
                                                                                fontWeight: '600',
                                                                                lineHeight: '17px',
                                                                            }}>
                                                                                {item.value}
                                                                            </span>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="text"
                                                                    style={{ minWidth: '200px', maxWidth: '200px' }}
                                                                    className="form-control common-input-all"
                                                                    value={row.specName || ''}
                                                                    onChange={(e) => {
                                                                        const newValue = e.target.value;
                                                                        setSkuCodeRows((prevRows) => {
                                                                            const updatedRows = [...prevRows];
                                                                            updatedRows[idx] = { ...updatedRows[idx], specName: newValue };
                                                                            return updatedRows;
                                                                        });
                                                                    }}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="text"
                                                                    style={{ minWidth: '200px', maxWidth: '200px' }}
                                                                    className="form-control common-input-all"
                                                                    value={row.gtin || ''}
                                                                    onChange={(e) => {
                                                                        const newValue = e.target.value;
                                                                        setSkuCodeRows((prevRows) => {
                                                                            const updatedRows = [...prevRows];
                                                                            updatedRows[idx] = { ...updatedRows[idx], gtin: newValue };
                                                                            return updatedRows;
                                                                        });
                                                                    }}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="text"
                                                                    style={{ minWidth: '200px', maxWidth: '200px' }}
                                                                    className="form-control common-input-all"
                                                                    value={row.skuCode || ''}
                                                                    onChange={(e) => {
                                                                        const newValue = e.target.value;
                                                                        setSkuCodeRows((prevRows) => {
                                                                            const updatedRows = [...prevRows];
                                                                            updatedRows[idx] = { ...updatedRows[idx], skuCode: newValue };
                                                                            return updatedRows;
                                                                        });
                                                                    }}
                                                                />
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                </div>
                {/* {discardModalOpen && (
                    <>
                        <div className="drawer-overlay" />
                        <div
                            className="entity-drawer modal-popup-cls"
                            ref={discardRef}
                            style={{
                                maxWidth: 650,
                                margin: "0 auto",
                                background: "white",
                                borderRadius: 12,
                                zIndex: 1050,
                                padding: 24,
                                position: "fixed",
                                top: "50%",
                                left: "50%",
                                transform: "translate(-50%, -50%)",
                                boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.2)",
                                height: "auto",
                                right: "auto",
                                overflow: "inherit",
                            }}
                        >
                            <div className="drawer-header d-flex justify-content-end align-items-center pt-0 pe-0">
                                <button className="close-btn" onClick={() => setDiscardModalOpen(false)}>
                                    <X size={20} />
                                </button>
                            </div>
                            <h3 style={{ textAlign: "left", color: "#212529", fontSize: "20px", fontWeight: "600", lineHeight: "24px", fontFamily: "Montserrat", marginBottom: "5px" }}>Are you sure?</h3>
                            <div className="drawer-footer" style={{ paddingTop: "10px", display: "flex", gap: "10px" }}>
                                <button className="btn-save" onClick={() => handleDiscardConfirm(true)}>
                                    Yes
                                </button>
                                <button className="btn-cancel" onClick={() => handleDiscardConfirm(false)}>
                                    No
                                </button>
                            </div>
                        </div>
                    </>
                )} */}

            </div > {/* end of company-body */}
        </>
    );
}

function EntityRow({ refNode, rowState: r, index: idx, deleteRow, updateRowBulk }) {
    const typeRef = useRef(null);
    const valueRef = useRef(null);
    const [portalStyle, setPortalStyle] = useState({});
    const [typePortalStyle, setTypePortalStyle] = useState({});

    // Position Field Value portal
    useEffect(() => {
        if (r.isOpen && valueRef.current) {
            const rect = valueRef.current.getBoundingClientRect();
            setPortalStyle({
                position: 'absolute',
                top: rect.bottom + window.scrollY,
                left: rect.left + window.scrollX,
                width: rect.width,
                background: '#fff',
                border: '1px solid #6c757d',
                borderRadius: '8px',
                overflow: 'visible',
                zIndex: 2000,
            });
        }
    }, [r.isOpen, r.opts, r.search]);


    // Position Field Type portal
    useEffect(() => {
        if (r.typeOpen && typeRef.current) {
            const rect = typeRef.current.getBoundingClientRect();
            setTypePortalStyle({
                position: 'absolute',
                top: rect.bottom + window.scrollY,
                left: rect.left + window.scrollX,
                width: rect.width,
                background: '#fff',
                border: '1px solid #6c757d',
                borderRadius: '8px',
                zIndex: 2000,
            });
        }
    }, [r.typeOpen]);

    return (
        <tr ref={refNode} style={{ position: (r.isOpen || r.typeOpen || r.refMenuOpen) ? 'relative' : 'static', zIndex: (r.isOpen || r.typeOpen || r.refMenuOpen) ? 1000 : 'auto' }}>
            <td><button className="btn p-0" onClick={() => deleteRow(r.id)} style={{ boxShadow: 'none' }}><Trash2 size={18} /></button></td>
            {/* <td>{idx + 1}</td> */}
            <td style={{ minWidth: '200px', maxWidth: '200px' }}><input className="form-control common-input-all" value={r.fieldName} onChange={e => updateRowBulk(r.id, { fieldName: e.target.value })} /></td>
            {/* FIELD TYPE unchanged */}
            <td style={{ position: 'relative', minWidth: '200px', maxWidth: '200px' }}>
                <div
                    ref={typeRef}
                    className="form-select new-form-select-cls"
                    onClick={() => updateRowBulk(r.id, { typeOpen: !r.typeOpen })}
                    style={{
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        padding: '0.5rem',
                        minHeight: '40px',
                        background: 'none',
                    }}
                >
                    <span style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                        {r.fieldType === 'Text' ? (
                            'Text'
                        )
                            : (
                                <>
                                    Reference
                                    <span className="pill">{r.refChild}</span>
                                </>
                            )
                        }
                    </span>
                    <ChevronDown size={16} style={{ transform: r.typeOpen ? 'rotate(180deg)' : 'rotate(0)' }} />
                </div>

                {r.typeOpen && (
                    <OptionPortal style={typePortalStyle}>
                        <ul
                            className="custom-check"
                            style={{
                                margin: 0,
                                padding: 0,
                                listStyle: 'none',
                                overflow: 'visible',
                                position: 'relative',
                            }}
                        >
                            {/* TEXT OPTION */}
                            <li
                                style={{
                                    padding: '0.5rem 1rem',
                                    cursor: 'pointer',
                                    fontFamily: 'Montserrat',
                                    fontSize: '14px',
                                }}
                                onClick={() =>
                                    updateRowBulk(r.id, {
                                        fieldType: 'Text',
                                        refChild: '',
                                        value: '',
                                        opts: [],
                                        typeOpen: false,
                                    })
                                }
                            >
                                Text
                            </li>

                            {/* REFERENCE OPTION */}
                            {/* <li style={{ borderTop: '1px solid #eee', position: 'relative' }}>
                                <div
                                    style={{
                                        padding: '0.5rem 1rem',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                        cursor: 'pointer',
                                        backgroundColor: r.refMenuOpen ? '#FFFEF0' : '#FFFEF0',
                                        fontFamily: 'Montserrat',
                                        fontSize: '14px',
                                        borderRadius: '0px 0px 8px 8px',
                                    }}
                                    onClick={() => updateRowBulk(r.id, { refMenuOpen: !r.refMenuOpen })}
                                >
                                    Reference
                                    <ChevronRight size={14} style={{ transform: r.refMenuOpen ? 'rotate(90deg)' : 'rotate(0)' }} />
                                </div>

                                {r.refMenuOpen && (
                                    <ul
                                        style={{
                                            listStyle: 'none',
                                            margin: 0,
                                            padding: '0.5rem 0',
                                            position: 'absolute',
                                            left: '100%',
                                            top: 0,
                                            background: 'white',
                                            border: '1px solid #eee',
                                            borderRadius: '4px',
                                            boxShadow: '0 4px 8px rgba(0,0,0,0.05)',
                                            zIndex: 10,
                                        }}
                                    >
                                        {REFERENCE_CHILDREN.map((opt) => (
                                            <li
                                                key={opt}
                                                style={{
                                                    padding: '0.5rem 1.5rem',
                                                    cursor: 'pointer',
                                                    fontFamily: 'Montserrat',
                                                    fontSize: '14px',
                                                    backgroundColor: r.refChild === opt ? '#FFFEF0' : 'transparent',
                                                }}
                                                onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#FFFEF0')}
                                                onMouseLeave={(e) =>
                                                    (e.currentTarget.style.backgroundColor = r.refChild === opt ? '#FFFEF0' : 'transparent')
                                                }
                                                onClick={() =>
                                                    updateRowBulk(r.id, {
                                                        fieldType: 'Reference',
                                                        refChild: opt,
                                                        isOpen: true,
                                                        typeOpen: false,
                                                        refMenuOpen: false,
                                                        opts: [],
                                                    })
                                                }
                                            >
                                                {opt}
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </li> */}
                        </ul>
                    </OptionPortal>
                )}
            </td>
            {/* FIELD VALUE with portal */}
            <td style={{ position: 'relative', minWidth: '200px', maxWidth: '200px' }}>
                {r.fieldType === 'Text' ? (
                    <input
                        className="form-control common-input-all"
                        value={r.value}
                        onChange={(e) => updateRowBulk(r.id, { value: e.target.value })}
                    />
                ) : (
                    <>
                        <div
                            ref={valueRef}
                            className="select-box form-control common-input-all"
                            onClick={() => updateRowBulk(r.id, { isOpen: !r.isOpen })}
                            style={{
                                padding: '0.5rem',
                                display: 'flex',
                                alignItems: 'center',
                                flexWrap: 'wrap',
                                cursor: 'pointer',
                                minHeight: '40px',
                            }}
                        >
                            {r.opts.length > 0 ? (
                                <>
                                    <span
                                        className="tag"
                                        style={{
                                            fontSize: '14px',
                                            fontWeight: '400',
                                            backgroundColor: 'transparent',
                                            color: '#6C757D',
                                            maxWidth: '100%',
                                            whiteSpace: 'nowrap',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                        }}
                                    >
                                        {r.opts[0].label}
                                    </span>
                                    {r.opts.length > 1 && (
                                        <span style={{ width: '24px', height: '24px', borderRadius: '50%', marginLeft: '5px', fontSize: '12px', fontWeight: '600', backgroundColor: '#212529', color: '#fff', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                            +{r.opts.length - 1}
                                        </span>
                                    )}
                                </>
                            ) : (
                                <span style={{ color: '#999' }}>Select {r.refChild}</span>
                            )}
                            <ChevronDown size={16} style={{ marginLeft: 'auto', transform: r.isOpen ? 'rotate(180deg)' : 'rotate(0)' }} />
                        </div>

                        {r.isOpen && (
                            <OptionPortal style={portalStyle}>
                                {/* SEARCH FIELD */}
                                <div style={{ padding: '0.5rem', position: 'relative' }}>
                                    <Search
                                        size={18}
                                        style={{
                                            position: 'absolute',
                                            top: '50%',
                                            left: '18px',
                                            transform: 'translateY(-50%)',
                                            color: '#6c757d',
                                        }}
                                    />
                                    <input
                                        type="text"
                                        className="form-control common-input-all search-input select-box"
                                        placeholder="Search..."
                                        value={r.search}
                                        onChange={(e) => updateRowBulk(r.id, { search: e.target.value })}
                                        style={{ paddingLeft: '2rem' }}
                                    />
                                </div>

                                {/* SEARCH RESULTS HEADER */}
                                <div style={{ padding: '0 15px 16px', fontSize: '12px', fontWeight: '400', color: '#6C757D' }}>
                                    Search Results
                                </div>

                                {/* SEARCH RESULTS */}
                                <ul
                                    className="options-list custom-check info-inner"
                                    style={{ listStyle: 'none', margin: 0, padding: '0 1.25rem 0.75rem' }}
                                >
                                    {REFERENCE_OPTIONS[r.refChild]
                                        .filter(opt => opt.label.toLowerCase().includes(r.search.toLowerCase()))
                                        .filter(opt => !r.opts.some(o => o.value === opt.value))
                                        .map(opt => (
                                            <li key={opt.value} style={{ marginBottom: '8px' }}>
                                                <label
                                                    className="option-item"
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        cursor: 'pointer',
                                                        fontSize: '0.9rem',
                                                        fontWeight: '400',
                                                        lineHeight: '1.4',
                                                    }}
                                                >
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input"
                                                        style={{ marginRight: '8px', marginTop: '2px', cursor: 'pointer' }}
                                                        checked={false}
                                                        onChange={() => updateRowBulk(r.id, { opts: [...r.opts, opt] })}
                                                    />
                                                    {renderLabel(opt.label)}
                                                </label>
                                            </li>
                                        ))}

                                </ul>

                                {/* SELECTED RESULTS HEADER */}
                                {r.opts.length > 0 && (
                                    <div style={{ padding: '0 15px 16px', fontSize: '12px', lineHeight: '15px', fontWeight: '400', color: '#6C757D' }}>
                                        Selected
                                    </div>
                                )}

                                {/* SELECTED OPTIONS */}
                                {r.opts.length > 0 && (
                                    <ul
                                        className="selected-list custom-check info-inner"
                                        style={{ listStyle: 'none', margin: 0, padding: '0 1.25rem 1rem' }}
                                    >
                                        {r.opts.map(opt => (
                                            <li key={opt.value} style={{ marginBottom: '0.5rem' }}>
                                                <label
                                                    className="option-item"
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        cursor: 'pointer',
                                                        fontSize: '0.9rem',
                                                        fontWeight: '400',
                                                        lineHeight: '1.4',
                                                    }}
                                                >
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input"
                                                        style={{ marginRight: '8px', marginTop: '2px', cursor: 'pointer' }}
                                                        checked={true}
                                                        onChange={() =>
                                                            updateRowBulk(r.id, {
                                                                opts: r.opts.filter(o => o.value !== opt.value),
                                                            })
                                                        }
                                                    />
                                                    {renderLabel(opt.label)}
                                                </label>
                                            </li>
                                        ))}

                                    </ul>
                                )}
                            </OptionPortal>
                        )}
                    </>
                )}
            </td>

            <td className="drag-handle" style={{ cursor: 'grab' }}><Menu size={18} /></td>
        </tr>
    );
}
function VariationRow({ refNode, rowState: r, deleteRow, updateRow, skuAttributes, skuAttributeOptions, rows2 }) {
    const valueRef = useRef(null);
    const [portalStyle, setPortalStyle] = useState({});

    useEffect(() => {
        if (r.isOpen && valueRef.current) {
            const rect = valueRef.current.getBoundingClientRect();
            setPortalStyle({
                position: 'absolute',
                top: rect.bottom + window.scrollY,
                left: rect.left + window.scrollX,
                width: rect.width,
                background: '#fff',
                border: '1px solid #6c757d',
                borderRadius: '8px',
                overflow: 'visible',
                zIndex: 2000,
            });
        }
    }, [r.isOpen, r.opts, r.search]);

    // Get the options for the selected attribute, excluding already selected options in other rows
    const getAttributeOptions = () => {
        if (!r.fieldName) return [];
        // Get all options selected in other rows for the same attribute
        const selectedOptions = (rows2 || [])
            .filter(row => row.id !== r.id && row.fieldName === r.fieldName)
            .flatMap(row => row.opts.map(opt => opt.value));

        // Filter options by the selected attribute_id and map to { label, value }
        const options = skuAttributeOptions
            .filter(opt => opt.attribute.toString() === r.fieldName)
            .map(opt => ({
                label: opt.option_value,
                value: opt.option_value
            }))
            .filter(opt => !selectedOptions.includes(opt.value)); // Exclude already selected options
        return options;
    };

    // Get available attributes, excluding already selected ones
    const availableAttributes = skuAttributes.filter(
        attr => !(rows2 || []).some(row => row.id !== r.id && row.fieldName === attr.attribute_id.toString())
    );

    return (
        <tr
            ref={refNode}
            style={{
                position: r.isOpen ? 'relative' : 'static',
                zIndex: r.isOpen ? 1000 : 'auto',
            }}
        >
            {/* DELETE ICON */}
            <td style={{ width: "40px" }}>
                <button className="btn p-0" onClick={() => deleteRow(r.id)} style={{ boxShadow: 'none' }}>
                    <Trash2 size={18} />
                </button>
            </td>

            {/* SKU VARIATION DROPDOWN */}
            <td style={{ minWidth: '200px' }}>
                <select
                    className="form-select new-form-select-cls"
                    value={r.fieldName}
                    onChange={e => updateRow(r.id, { fieldName: e.target.value, opts: [] })}
                >
                    <option value="">Select Variation</option>
                    {availableAttributes.map(attr => (
                        <option key={attr.attribute_id} value={attr.attribute_id}>
                            {attr.attribute_name}
                        </option>
                    ))}
                </select>
            </td>

            {/* VARIATION OPTIONS MULTI SELECT */}
            <td style={{ minWidth: "200px", position: "relative" }}>
                <div
                    ref={valueRef}
                    className="select-box form-control common-input-all"
                    onClick={() => updateRow(r.id, { isOpen: !r.isOpen })}
                    style={{
                        padding: '0.5rem',
                        display: 'flex',
                        alignItems: 'center',
                        flexWrap: 'wrap',
                        cursor: 'pointer',
                        minHeight: '40px',
                    }}
                >
                    {r.opts.length ? (
                        r.opts.map(opt => (
                            <span
                                key={opt.value}
                                className="tag"
                                style={{
                                    backgroundColor: '#FFEB00',
                                    color: '#212529',
                                    borderRadius: '16px',
                                    padding: '4px 8px',
                                    margin: '2px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    fontSize: '12px',
                                    fontWeight: '600',
                                }}
                            >
                                {opt.label}
                                <button
                                    type="button"
                                    style={{ background: 'none', border: 'none', marginLeft: '8px', cursor: 'pointer' }}
                                    onClick={e => {
                                        e.stopPropagation();
                                        updateRow(r.id, { opts: r.opts.filter(o => o.value !== opt.value) });
                                    }}
                                >
                                    <X size={14} strokeWidth={3} />
                                </button>
                            </span>
                        ))
                    ) : (
                        <span style={{ color: '#999' }}>Select values…</span>
                    )}

                    <ChevronDown
                        size={16}
                        style={{ marginLeft: 'auto', transform: r.isOpen ? 'rotate(180deg)' : 'rotate(0)' }}
                    />
                </div>

                {/* OPTIONS DROPDOWN PORTAL */}
                {r.isOpen && (
                    <OptionPortal style={portalStyle}>
                        <div style={{ padding: '0.5rem', position: 'relative' }}>
                            <Search
                                size={18}
                                style={{ position: 'absolute', top: '50%', left: '18px', transform: 'translateY(-50%)', color: '#6c757d' }}
                            />
                            <input
                                type="text"
                                className="form-control common-input-all search-input select-box"
                                placeholder="Search..."
                                value={r.search}
                                onChange={e => updateRow(r.id, { search: e.target.value })}
                                style={{ paddingLeft: '2rem' }}
                            />
                        </div>

                        <ul style={{ listStyle: "none", padding: "1rem", margin: 0 }}>
                            {getAttributeOptions()
                                .filter(o => o.label.toLowerCase().includes(r.search.toLowerCase()))
                                .map(opt => (
                                    <li key={opt.value} style={{ marginBottom: "0.5rem" }}>
                                        <label style={{ display: "flex", alignItems: "center" }}>
                                            <input
                                                type="checkbox"
                                                checked={r.opts.some(o => o.value === opt.value)}
                                                onChange={() => {
                                                    const exists = r.opts.some(o => o.value === opt.value);
                                                    updateRow(r.id, {
                                                        opts: exists ? r.opts.filter(o => o.value !== opt.value) : [...r.opts, opt]
                                                    });
                                                }}
                                                style={{ marginRight: "8px" }}
                                            />
                                            {opt.label}
                                        </label>
                                    </li>
                                ))}

                            {getAttributeOptions().length === 0 && (
                                <li style={{ color: "#999", textAlign: "center" }}>No options available</li>
                            )}
                        </ul>
                    </OptionPortal>
                )}
            </td>

            {/* DRAG HANDLE */}
            <td style={{ width: "40px", cursor: "grab" }} className="drag-handle">
                <Menu size={18} />
            </td>
        </tr>
    );

}
function ConfigRow({ refNode, rowState: r, index: idx, deleteRow, updateRow, rows2, skuAttributes }) {
    const valueRef = useRef(null);
    const [portalStyle, setPortalStyle] = useState({});

    useEffect(() => {
        if (r.isOpen && valueRef.current) {
            const rect = valueRef.current.getBoundingClientRect();
            setPortalStyle({
                position: 'absolute',
                top: rect.bottom + window.scrollY,
                left: rect.left + window.scrollX,
                width: rect.width,
                background: '#fff',
                border: '1px solid #6c757d',
                borderRadius: '8px',
                padding: '1rem',
                zIndex: 2000,
            });
        }
    }, [r.isOpen, r.opts]);

    const toggleOption = (group, option) => {
        // Keep only one option per group
        const newOpts = r.opts.filter(o => !o.startsWith(`${group}:`)); // Remove existing option for this group
        updateRow(r.id, {
            opts: [...newOpts, `${group}:${option}`], // Add the new selected option
        });
    };

    // Get variation options from rows2
    const variationOptions = rows2.reduce((acc, row) => {
        if (row.fieldName && row.opts.length > 0) {
            const attribute = skuAttributes.find(attr => attr.attribute_id.toString() === row.fieldName);
            const groupName = attribute ? attribute.attribute_name : `Attribute ${row.id}`;
            acc[groupName] = row.opts.map(opt => opt.label);
        }
        return acc;
    }, {});

    return (
        <tr ref={refNode} style={{ position: r.isOpen ? 'relative' : 'static', zIndex: r.isOpen ? 1000 : 'auto' }}>
            <td>
                <button className="btn p-0" onClick={() => deleteRow(r.id)} style={{ boxShadow: 'none' }}>
                    <Trash2 size={18} />
                </button>
            </td>
            {/* <td>{idx + 1}</td> */}
            <td style={{ minWidth: '200px', maxWidth: '200px' }}>
                <input
                    className="form-control common-input-all"
                    value={r.fieldName}
                    onChange={e => updateRow(r.id, { fieldName: e.target.value })}
                />
            </td>
            <td style={{ position: 'relative', minWidth: '300px', maxWidth: '300px' }}>
                <div
                    ref={valueRef}
                    className="select-box form-control common-input-all"
                    onClick={() => updateRow(r.id, { isOpen: !r.isOpen })}
                    style={{ cursor: 'pointer', minHeight: '40px', padding: '0.5rem', display: 'flex', flexWrap: 'wrap', gap: '4px' }}
                >
                    {r.opts.length ? r.opts.map(val => {
                        const [grp, opt] = val.split(':');
                        return (
                            <span key={val} className="tag" style={{ backgroundColor: '#FFEB00', color: '#212529', borderRadius: '16px', padding: '4px 8px', fontSize: '12px', fontWeight: '600', display: 'flex', alignItems: 'center', gap: '4px' }}>
                                {opt}
                                <button type="button" style={{ background: 'none', border: 'none', cursor: 'pointer' }} onClick={e => { e.stopPropagation(); toggleOption(grp, opt); }}>
                                    <X size={14} strokeWidth={3} />
                                </button>
                            </span>
                        );
                    }) : <span style={{ color: '#999' }}>Select options…</span>}
                    <ChevronDown size={16} style={{ marginLeft: 'auto', transform: r.isOpen ? 'rotate(180deg)' : 'rotate(0)' }} />
                </div>

                {r.isOpen && (
                    <OptionPortal style={portalStyle}>
                        {Object.entries(variationOptions).map(([group, opts]) => (
                            <div key={group} style={{ marginBottom: '1rem' }}>
                                <strong style={{ display: 'block', marginBottom: '0.5rem', fontSize: '14px', fontWeight: '600', color: '#6C757D' }}>{group}</strong>
                                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                                    {opts.map(opt => {
                                        const key = `${group}:${opt}`;
                                        const selected = r.opts.includes(key);
                                        return (
                                            <label key={key} style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', fontSize: '12px', fontWeight: '600' }}>
                                                <input
                                                    type="radio"
                                                    name={`option-${group}-${r.id}`}
                                                    checked={selected}
                                                    onChange={() => toggleOption(group, opt)}
                                                    style={{ marginRight: '8px' }}
                                                />
                                                {opt}
                                            </label>
                                        );
                                    })}
                                </div>
                            </div>
                        ))}
                        {Object.keys(variationOptions).length === 0 && (
                            <div style={{ color: '#999', textAlign: 'center', fontSize: '0.9rem' }}>
                                No variation options available
                            </div>
                        )}
                    </OptionPortal>
                )}
            </td>
            <td className="drag-handle" style={{ cursor: 'grab' }}><Menu size={18} /></td>
        </tr>
    );
}
function CompatibilitySelect({ tabKey, allCompatibility }) {
    const [selectedCompatibility, setSelectedCompatibility] = useState([]);
    const [isCompatibilityOpen, setIsCompatibilityOpen] = useState(false);
    const [compatibilitySearch, setCompatibilitySearch] = useState('');
    const compatibilityRef = useRef(null);

    const toggleCompatibility = () => {
        setIsCompatibilityOpen((prev) => !prev);
    };

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (isCompatibilityOpen && compatibilityRef.current && !compatibilityRef.current.contains(e.target)) {
                setIsCompatibilityOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isCompatibilityOpen]);

    const filteredCompatibility = allCompatibility.filter((g) =>
        g.role_name.toLowerCase().includes(compatibilitySearch.trim().toLowerCase())
    );

    const handleCompatibilityCheckbox = (group) => {
        const exists = selectedCompatibility.findIndex((item) => item.id === group.id);
        if (exists > -1) {
            setSelectedCompatibility((prev) => prev.filter((item) => item.id !== group.id));
        } else {
            setSelectedCompatibility((prev) => [...prev, group]);
        }
    };

    const removeCompatibility = (valueToRemove) => {
        setSelectedCompatibility((prev) =>
            prev.filter((item) => item.id !== valueToRemove)
        );
    };

    return (
        <div className="info-inner" ref={compatibilityRef} style={{ position: 'relative' }}>
            <label className="form-label d-flex align-items-center gap-2">
                Compatibility
                <Tooltip content="Select one or more Compatibilitys for this configuration">
                    <Info size={16} className="info-icon" />
                </Tooltip>
            </label>
            <div
                className="select-box form-control common-input-all"
                onClick={toggleCompatibility}
                style={{
                    padding: '0.5rem',
                    minHeight: '40px',
                    display: 'flex',
                    alignItems: 'center',
                    flexWrap: 'wrap',
                    position: 'relative',
                    cursor: 'pointer',
                }}
            >
                {selectedCompatibility.length > 0 ? (
                    selectedCompatibility.map((g) => (
                        <span
                            key={g.id}
                            className="tag"
                            style={{
                                backgroundColor: '#FFEB00',
                                color: '#212529',
                                borderRadius: '16px',
                                padding: '4px 8px',
                                margin: '2px',
                                display: 'flex',
                                alignItems: 'center',
                                fontSize: '12px',
                                fontWeight: '600',
                                lineHeight: 'normal',
                            }}
                        >
                            {g.role_name}
                            <button
                                type="button"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    removeCompatibility(g.id);
                                }}
                                style={{
                                    background: 'none',
                                    border: 'none',
                                    marginLeft: '20px',
                                    cursor: 'pointer',
                                    fontSize: '16px',
                                    padding: '0',
                                    lineHeight: '14px',
                                }}
                            >
                                <X size={14} strokeWidth={3} />
                            </button>
                        </span>
                    ))
                ) : (
                    <span style={{ color: '#999', fontSize: '0.9rem' }}>
                        Select Compatibility
                    </span>
                )}
                <span
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        marginLeft: 'auto',
                        gap: '0.25rem',
                        fontSize: '0.8rem',
                        color: '#666',
                    }}
                >
                    {selectedCompatibility.length > 0 && (
                        <span>{selectedCompatibility.length} selected</span>
                    )}
                    <ChevronDown
                        size={16}
                        style={{
                            transform: isCompatibilityOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                            transition: 'transform 0.2s',
                            userSelect: 'none',
                        }}
                    />
                </span>
            </div>
            {isCompatibilityOpen && (
                <div
                    className="options-container"
                    style={{
                        border: '1px solid #6c757d',
                        borderRadius: '8px',
                        marginTop: '4px',
                        maxHeight: '270px',
                        overflowY: 'auto',
                        background: '#fff',
                        position: 'absolute',
                        top: '100%',
                        left: 0,
                        zIndex: 1000,
                        width: '100%',
                        boxShadow: '0px 1px 4px 0px #0000001A',
                    }}
                    onWheel={(e) => e.preventDefault()}
                >
                    <div style={{ padding: '0.5rem', position: 'relative' }}>
                        <Search
                            size={18}
                            style={{
                                position: 'absolute',
                                top: '50%',
                                left: '18px',
                                transform: 'translateY(-50%)',
                                color: '#6C757D',
                                pointerEvents: 'none',
                            }}
                        />
                        <input
                            type="text"
                            className="search-input select-box form-control common-input-all"
                            placeholder="Search..."
                            value={compatibilitySearch}
                            onChange={(e) => setCompatibilitySearch(e.target.value)}
                            style={{
                                width: '100%',
                                padding: '0.5rem 0.5rem 0.5rem 2rem',
                                fontSize: '0.9rem',
                                outline: 'none',
                            }}
                        />
                    </div>
                    <ul
                        className="options-list custom-check"
                        style={{
                            listStyle: 'none',
                            margin: 0,
                            padding: '1.25rem',
                        }}
                    >
                        {filteredCompatibility.map((g) => (
                            <li key={g.id} style={{ marginBottom: '0.5rem' }}>
                                <label
                                    className="option-item"
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        cursor: 'pointer',
                                        fontSize: '0.9rem',
                                        fontWeight: 'normal',
                                    }}
                                >
                                    <input
                                        type="checkbox"
                                        className="form-check-input"
                                        checked={
                                            selectedCompatibility.findIndex(
                                                (item) => item.id === g.id
                                            ) > -1
                                        }
                                        onChange={() => handleCompatibilityCheckbox(g)}
                                        style={{ marginRight: '8px' }}
                                    />
                                    {g.role_name}
                                </label>
                            </li>
                        ))}
                        {filteredCompatibility.length === 0 && (
                            <li style={{ color: '#999', textAlign: 'center', fontSize: '0.9rem' }}>
                                No Compatibility found
                            </li>
                        )}
                    </ul>
                </div>
            )}
            <style>
                {`
  input[type="date"]:invalid::-webkit-datetime-edit {
    color: transparent;
  }

  input[type="date"]:valid::-webkit-datetime-edit {
    color: black;
  }

  input[type="date"]:focus::-webkit-datetime-edit {
    color: black;
  }
`}
            </style>

        </div>
    );
}
